<template>
    <div class="instance-detail">
        <div class="jc-page-header">
            <el-page-header show-back-icon :title="$t('privateNetInstance.cps')" @back="goBack" class="relative" :class="detail.status === 'destroying' ? 'destroying-header' : ''">
                <template slot="content">
                    <span class="long-name" :title="detail.name">
                        {{ detail.name }}
                    </span>
                    <div :class="getClassByStatue(detail.status)" class="jc-status-pl">
                        <span class="icon-status icon-stopped icon-run"
                            v-if="detail.status !== 'running' && detail.status !== 'stopped'">
                        </span>
                        {{ transFormStatusName(detail.status) }}
                    </div>
                    <!-- 帮助文档及操作 -->
                    <div class="jc-list__header--right jc-box-action">
                        <a :href="Config.CPS_HELP_URL" target="_blank">
                            {{ $t('privateNetInstance.helpDoc') }}
                        </a>
                        <drop-down-operation :buttonTitle="$t('privateNetInstance.operate')" :operations='ops'
                            @clickSelectItem="clickOperate" v-loading="isDropDownOperationLoading">
                        </drop-down-operation>
                    </div>
                </template>
            </el-page-header>
        </div>
        <div class="jc-page-content">
            <el-tabs ref="pageTabs" type="border-card" @tab-click="changeTab" v-model="tabName">
                <!-- tab:资源信息 -->
                <el-tab-pane :label="$t('privateNetInstance.sourceInfo')" name="sourceInfo"
                    :disabled="tabName === 'sourceInfo'">
                    <!-- 基本信息 -->
                    <div class="jc-section">
                        <div class="jc-section-header">
                            <h3 class="jc-section-title">{{ $t('privateNetInstance.baseInfo') }}</h3>
                        </div>
                        <div class="jc-section-content">
                            <el-form class="base-info-list" @submit.stop.prevent>
                                <el-row :gutter="20">
                                    <!--ID-->
                                    <el-col :span="8">
                                        <el-form-item :label="$t('privateNetInstance.id') | withColon">
                                            <span>{{ detail.instanceId }}</span>
                                            <copy-value :copyVal="detail.instanceId"></copy-value>
                                        </el-form-item>
                                    </el-col>
                                    <!--名称-->
                                    <el-col :span="8">
                                        <el-form-item :label="$t('privateNetInstance.name') | withColon"
                                            class="edit-jc-form">
                                            <span :title="detail.name" class="instance-name">{{ detail.name }}</span>
                                            <el-popover ref="editValue" trigger="click" :visible-arrow="false" :offset="0"
                                                placement="left-start" :width="300" v-if="showEditName"
                                                :value="showEditName">
                                                <edit-value :inputVal="detail.name" v-if="showEditName" @sureEdit="editName"
                                                    :inputValRule="rules.name" :showEditDes.sync="showEditName"
                                                    :popTitle="$t('privateNetwork.editName')">
                                                </edit-value>
                                            </el-popover>
                                            <el-button type="text" icon="jc-icon-edit" @click="showEditName = true"
                                                v-popover:editValue>
                                            </el-button>
                                            <div class="jc-colude-mask" v-if="showEditName"></div>
                                        </el-form-item>
                                    </el-col>
                                    <!--节点-->
                                    <el-col :span="8">
                                        <el-form-item :label="$t('privateNetInstance.region') | withColon">
                                            <span>{{ regions[detail.region] }}</span>
                                        </el-form-item>
                                    </el-col>
                                    <!--可用区-->
                                    <el-col :span="8">
                                        <el-form-item :label="$t('privateNetInstance.valArea') | withColon">
                                            <span>{{ regions[detail.az] }}</span>
                                        </el-form-item>
                                    </el-col>
                                    <!--Agent状态-->
                                    <el-col :span="8">
                                        <agent-status :data="!parseInt(detail.agentStatus, 10)" />
                                    </el-col>
                                    <!--标签-->
                                    <el-col :span="8">
                                        <el-form-item :label="$t('listPage.text.tags') | withColon" class="edit-jc-form">
                                            <span class="instance-name" :title="detail.tagPairs | maybeEmpty">
                                                {{ detail.tagPairs | maybeEmpty }}
                                            </span>
                                        </el-form-item>
                                    </el-col>
                                    <!--实例删除保护-->
                                    <el-col :span="8">
                                        <el-form-item :label="$t('privateNetInstance.deleteProtect') | withColon"
                                            class="edit-jc-form">
                                            <span class="instance-name">
                                                {{ DeleteProtectStatusConstant[detail.removeProtect] | maybeEmpty }}
                                            </span>
                                        </el-form-item>
                                    </el-col>
                                    <!--描述-->
                                    <el-col :span="8">
                                        <el-form-item :label="$t('privateNetInstance.description') | withColon"
                                            class="edit-jc-form">
                                            <span :title="detail.description" class="instance-name">
                                                {{ detail.description }}
                                            </span>
                                            <el-popover ref="editDes" trigger="click" :visible-arrow="false" :offset="0"
                                                placement="left-start" :width="300" v-if="showEditDes" :value="showEditDes">
                                                <edit-value :inputVal="detail.description" v-if="showEditDes"
                                                    @sureEdit="editDes" :type="'textarea'" :inputValRule="rules.description"
                                                    :showEditDes.sync="showEditDes"
                                                    :popTitle="$t('privateNetwork.editDescription')">
                                                </edit-value>
                                            </el-popover>
                                            <el-button type="text" icon="jc-icon-edit" @click="showEditDes = true"
                                                v-popover:editDes>
                                            </el-button>
                                            <div class="jc-colude-mask" v-if="showEditDes"></div>
                                        </el-form-item>
                                    </el-col>
                                </el-row>
                            </el-form>
                        </div>
                    </div>
                    <el-divider></el-divider>
                    <!-- 计费信息 -->
                    <div class="jc-section">
                        <div class="jc-section-header">
                            <h3 class="jc-section-title">{{ $t('eip.text.billInfo') }}</h3>
                        </div>
                        <div class="jc-section-content">
                            <el-form class="base-info-list" @submit.stop.prevent>
                                <el-row :gutter="20">
                                    <!--计费类型-->
                                    <el-col :span="8">
                                        <el-form-item :label="$t('privateNetInstance.chargeType') | withColon">
                                            <span v-if="detail.charge && detail.charge.chargeMode">
                                                {{ transformChargeMode(detail.charge.chargeMode) }}
                                            </span>
                                            <span v-else>{{ '--' }}</span>
                                        </el-form-item>
                                    </el-col>
                                    <!--创建时间-->
                                    <el-col :span="8">
                                        <el-form-item :label="$t('privateNetInstance.createTime') | withColon">
                                            <span v-if="detail.charge && detail.charge.chargeStartTime">
                                                {{ detail.charge.chargeStartTime }}
                                            </span>
                                            <span v-else>{{ '--' }}</span>
                                        </el-form-item>
                                    </el-col>
                                    <!--到期时间-->
                                    <el-col :span="8" v-if="detail.chargeMode === ChargeModeConstant.PREPAID_BY_DURATION">
                                        <el-form-item :label="$t('privateNetInstance.expireTime') | withColon">
                                            <span v-if="detail.charge && detail.charge.chargeExpiredTime">
                                                {{ detail.charge.chargeExpiredTime }}
                                            </span>
                                            <span v-else> {{ '--' }}</span>
                                        </el-form-item>
                                    </el-col>
                                </el-row>
                            </el-form>
                        </div>
                    </div>
                    <el-divider></el-divider>
                    <!-- 配置信息 -->
                    <div class="jc-section">
                        <div class="jc-section-header">
                            <h3 class="jc-section-title">{{ $t('privateNetInstance.configInfo') }}</h3>
                        </div>
                        <div class="jc-section-content">
                            <el-form class="config-info-list">
                                <el-row :gutter="20">
                                    <!--镜像-->
                                    <el-col :span="8">
                                        <el-form-item :label="$t('privateNetInstance.mirror') | withColon">
                                            {{ detail.imageName }}
                                        </el-form-item>
                                    </el-col>
                                    <!--规格-->
                                    <el-col :span="8">
                                        <el-form-item :label="$t('privateNetInstance.spec') | withColon">
                                            <p :title="detail.spec" class="instance-name">{{ detail.spec }}</p>
                                        </el-form-item>
                                    </el-col>
                                    <!--CPU-->
                                    <el-col :span="8">
                                        <el-form-item :label="$t('create.text.cpu') | withColon">
                                            {{ (detail.deviceInfo && detail.deviceInfo.cpuDetail) | maybeEmpty }}
                                        </el-form-item>
                                    </el-col>
                                    <!--内存-->
                                    <el-col :span="8">
                                        <el-form-item :label="$t('create.text.memory') | withColon">
                                            <p class="english-word-wrap">{{ (detail.deviceInfo &&
                                                detail.deviceInfo.memDetail) | maybeEmpty }}</p>
                                        </el-form-item>
                                    </el-col>
                                    <!--系统盘-->
                                    <el-col :span="8">
                                        <el-form-item :label="$t('privateNetInstance.sysDisk') + ': '">
                                            {{ detail.systemDiskDesc }}
                                        </el-form-item>
                                    </el-col>
                                    <!--数据盘-->
                                    <el-col :span="8">
                                        <el-form-item :label="$t('privateNetInstance.dataDisk') + ': '">
                                            {{ detail.dataDiskDesc }}
                                        </el-form-item>
                                    </el-col>
                                    <!--GPU-->
                                    <el-col :span="8">
                                        <el-form-item :label="$t('create.text.gpu') | withColon">
                                            <p>{{ detail.graphics | maybeEmpty }}</p>
                                        </el-form-item>
                                    </el-col>
                                    <!--登录密钥-->
                                    <el-col :span="8">
                                        <el-form-item :label="$t('privateNetInstance.loginKeyPair') | withColon">
                                            <span :title="detail.keypairName" class="login-key">{{ detail.keypairName |
                                                maybeEmpty }}</span>
                                            <el-tooltip class="ml10" effect="dark" placement="right">
                                                <div slot="content" class="my-os-disk-tip">
                                                    {{ $t('privateNetInstance.initPairTip') }}
                                                </div>
                                                <a><i class="jc-icon-question"></i></a>
                                            </el-tooltip>
                                        </el-form-item>
                                    </el-col>
                                    <!--SOS密钥-->
                                    <el-col :span="8">
                                        <el-form-item :label="$t('privateNetInstance.SOSKeyPair') | withColon">
                                            <span>
                                                {{ detail.keypairNameSos | maybeEmpty }}
                                            </span>
                                            <el-tooltip class="ml10" effect="dark" placement="right">
                                                <div slot="content" class="my-os-disk-tip">
                                                    {{ $t('privateNetInstance.sosKeyTip') }}
                                                </div>
                                                <a><i class="jc-icon-question"></i></a>
                                            </el-tooltip>
                                        </el-form-item>
                                    </el-col>
                                    <!--最近一次安装系统分区参数-->
                                    <el-col :span="24">
                                        <el-form-item :label="$t('create.text.lastCustomPartition') | withColon"
                                            class="customPartition">
                                            <span v-if="detail.customSystemPartition">{{ $t('create.text.sysDisk') }}</span>
                                            <span v-if="detail.customSystemPartition"
                                                v-html="detail.customSystemPartition"></span>
                                            <span v-if="detail.customDataPartition">{{ $t('create.text.dataDisk') }}</span>
                                            <span v-if="detail.customDataPartition"
                                                v-html="detail.customDataPartition"></span>
                                            <span v-if="!detail.customSystemPartition && !detail.customDataPartition">{{
                                                detail.customSystemPartition
                                                | formatEmptyFilter }}</span>
                                        </el-form-item>
                                    </el-col>
                                </el-row>
                            </el-form>
                        </div>
                    </div>
                    <el-divider></el-divider>
                    <!-- 网络信息 -->
                    <div class="jc-section">
                        <div class="jc-section-header">
                            <h3 class="jc-section-title">{{ $t('privateNetInstance.networkInfo') }}</h3>
                        </div>
                        <div class="jc-section-content">
                            <el-form class="net-info-list">
                                <el-row :gutter="20">
                                    <el-col :span="8">
                                        <el-form-item :label="$t('eip.text.internetAccessType') | withColon">
                                            <span>{{ detail.interfaceMode === 'dual' ?
                                                $t('create.text.doubleInternetAccess') :
                                                $t('create.text.singleInternetAccess') }}</span>
                                        </el-form-item>
                                    </el-col>
                                    <el-col :span="8">
                                        <el-form-item :label="$t('create.text.networkName') | withColon">
                                            <span>{{ detail.interfaceMode === 'dual' ?
                                                $t('create.text.chiefAndSubInternetAccessName') :
                                                $t('create.text.singleInternetAccessChiefName') }}</span>
                                        </el-form-item>
                                    </el-col>
                                    <el-col :span="8">
                                        <el-form-item :label="$t('privateNetInstance.outConsole') | withColon">
                                            <el-button type="text" @click="sosFix" :disabled="resetSosDisable">{{
                                                detail.keypairIdSos !==
                                                undefined ? $t('privateNetInstance.operations.sos') :
                                                $t('privateNetInstance.operations.fixSOS') }}</el-button>
                                            <span v-if="detail.keypairIdSos !== undefined">{{ '|' }}</span>
                                            <el-button v-if="detail.keypairIdSos !== undefined" type="text"
                                                @click="sosReset" :disabled="resetSosDisable">{{
                                                    $t('privateNetInstance.operations.resetSOS') }}</el-button>
                                            <el-tooltip class="ml10" effect="dark" placement="right">
                                                <div slot="content" class="my-os-disk-tip">
                                                    {{ detail.keypairIdSos !==
                                                        undefined ? $t('privateNetInstance.sosTip') :
                                                        $t('privateNetInstance.fixSOSTip') }}
                                                </div>
                                                <a><i class="jc-icon-question"></i></a>
                                            </el-tooltip>
                                        </el-form-item>
                                    </el-col>
                                    <el-col :span="8">
                                        <el-form-item :label="$t('privateNetInstance.fireWall') | withColon">
                                            {{ $t('privateNetInstance.defaultFireWall') }}
                                            <a :href="Config.FIRE_HELP_URL" target="_blank">
                                                <i class="jc-icon-my-expand-arrows-alt"></i>
                                                {{ $t('privateNetInstance.operateGuid') }}
                                            </a>
                                        </el-form-item>
                                    </el-col>
                                </el-row>
                            </el-form>
                        </div>
                        <!-- 主网口 -->
                        <div class="jc-section-content">
                            <h3 class="jc-section-head">
                                {{ detail.interfaceMode === 'dual' ? $t('create.text.chiefInternetAccessName') :
                                    $t('create.text.singleInternetAccessChiefName') }}
                            </h3>
                            <el-form class="net-info-list">
                                <el-row :gutter="20">
                                    <el-col :span="8">
                                        <el-form-item :label="$t('privateNetInstance.networkType') | withColon">
                                            <span>{{ transformVpcName(detail.networkType) }}</span>
                                        </el-form-item>
                                    </el-col>
                                    <el-col :span="8">
                                        <el-form-item :label="$t('privateNetwork.privateNetwork') | withColon">
                                            <a href="javascript:void(0)"
                                                @click="jumpToVpcDetail(detail.vpcId, detail.region, detail.vpcName)">
                                                {{ detail.vpcName }}
                                            </a>
                                            <span>{{ '(' + detail.vpcCidr + ')' }}</span>
                                            <el-tooltip :disabled="!changeNetworkOperateDisable"
                                                :content='changeNetworkTip'>
                                                <span><el-button type="text" icon="jc-icon-edit"
                                                        :disabled="changeNetworkOperateDisable"
                                                        @click="changeVpcNetwork(0)">
                                                    </el-button></span>
                                            </el-tooltip>
                                        </el-form-item>
                                    </el-col>
                                    <el-col :span="8">
                                        <el-form-item :label="$t('privateNetInstance.subnet') | withColon">
                                            <a href="javascript:void(0)"
                                                @click="jumpToSubnet(detail.subnetId, detail.region)">
                                                {{ detail.subnetName }}
                                            </a>
                                            <el-tooltip :disabled="!changeNetworkOperateDisable"
                                                :content='changeNetworkTip'>
                                                <span><el-button type="text" icon="jc-icon-edit"
                                                        :disabled="changeNetworkOperateDisable"
                                                        @click="changeSubnetwork(0)">
                                                    </el-button></span>
                                            </el-tooltip>
                                        </el-form-item>
                                    </el-col>
                                    <el-col :span="8">
                                        <el-form-item :label="$t('detail.text.interNetIpv4') | withColon">
                                            <span>{{ detail.privateIp }}</span>
                                            <el-tooltip :disabled="!changeNetworkOperateDisable"
                                                :content='changeNetworkTip'>
                                                <span><el-button type="text" icon="jc-icon-edit"
                                                        :disabled="changeNetworkOperateDisable" @click="changeIPnetwork(0)">
                                                    </el-button></span>
                                            </el-tooltip>
                                        </el-form-item>
                                    </el-col>
                                    <el-col :span="8">
                                        <el-form-item :label="$t('detail.text.publicNetIpv4') | withColon">
                                            <span v-if="detail.enableInternet === 'yes'">
                                                <a href="javascript:void(0)"
                                                    @click="jumpToEip(detail.elasticIpId, detail.region)">
                                                    {{ detail.publicIp }}
                                                </a>
                                            </span>
                                            <span v-else>
                                                {{ '--' }}
                                            </span>
                                        </el-form-item>
                                    </el-col>
                                    <el-col :span="8">
                                        <el-form-item :label="$t('detail.text.interNetIpv6') | withColon">
                                            <span v-if="detail.ipv6Address">{{ detail.ipv6Address }}</span>
                                            <a v-else @click="openIpv6PrivateNetInstance('chiefInternetAccess')"
                                                href="javascript:void(0)"
                                                :class="{ 'cps-dropdown-disabled': (!detail.subnetIpv6Cidr || !detail.vpcIpv6Cidr) }">{{
                                                    this.$t('privateNetInstance.operations.ipv6') }}</a>
                                        </el-form-item>
                                    </el-col>
                                    <el-col :span="8" v-if="detail.ipv6Address">
                                        <el-form-item :label="$t('privateNetInstance.isEnableIPv6') | withColon">
                                            <span v-if="detail.ipv6AddressId">{{
                                                this.$t('privateNetInstance.hasEnabledIPv6') }}</span>
                                            <span v-else>
                                                {{ this.$t('privateNetInstance.hasDisabledIPv6') }}
                                                <a @click="jumpToIpv6Detail('chiefInternetAccess')"
                                                    href="javascript:void(0)">{{
                                                        this.$t('privateNetInstance.enablePublicNet') }}</a>
                                            </span>
                                        </el-form-item>
                                    </el-col>
                                    <el-col :span="8">
                                        <el-form-item :label="$t('detail.text.bondedAliasIpRange') | withColon">
                                            <a href="javascript:void(0)" @click="jumpToNetAccessDetail">
                                                {{ detail.isCheckAliasIpTotal }}
                                            </a>
                                        </el-form-item>
                                    </el-col>
                                    <el-col :span="8">
                                        <el-form-item :label="$t('detail.text.bondedIPv6AliasIpRange') | withColon">
                                            <a href="javascript:void(0)" @click="jumpToNetAccessDetail">
                                                {{ detail.isCheckIpv6AliasIpTotal }}
                                            </a>
                                        </el-form-item>
                                    </el-col>
                                </el-row>
                            </el-form>
                        </div>
                        <!-- 辅网口 -->
                        <div class="jc-section-content" v-if="detail.interfaceMode === 'dual'">
                            <h3 class="jc-section-head">{{ $t('create.text.subInternetAccessName') }}
                            </h3>
                            <el-form class="net-info-list">
                                <el-row :gutter="20">
                                    <el-col :span="8">
                                        <el-form-item :label="$t('privateNetInstance.networkType') | withColon">
                                            <span>{{ transformVpcName(detail.networkType) }}</span>
                                        </el-form-item>
                                    </el-col>
                                    <el-col :span="8">
                                        <el-form-item :label="$t('privateNetwork.privateNetwork') | withColon">
                                            <a href="javascript:void(0)"
                                                @click="jumpToVpcDetail(detail.extensionVpcId, detail.region, detail.extensionVpcName)">
                                                {{ detail.extensionVpcName }}
                                            </a>
                                            <span>{{ '(' + detail.extensionVpcCidr + ')' }}</span>
                                            <el-tooltip :disabled="!changeNetworkOperateDisable"
                                                :content='changeNetworkTip'>
                                                <span><el-button type="text" icon="jc-icon-edit"
                                                        :disabled="changeNetworkOperateDisable"
                                                        @click="changeVpcNetwork(1)">
                                                    </el-button></span>
                                            </el-tooltip>
                                        </el-form-item>
                                    </el-col>
                                    <el-col :span="8">
                                        <el-form-item :label="$t('privateNetInstance.subnet') | withColon">
                                            <a href="javascript:void(0)"
                                                @click="jumpToSubnet(detail.extensionSubnetId, detail.region)">
                                                {{ detail.extensionSubnetName }}
                                            </a>
                                            <el-tooltip :disabled="!changeNetworkOperateDisable"
                                                :content='changeNetworkTip'>
                                                <span><el-button type="text" icon="jc-icon-edit"
                                                        :disabled="changeNetworkOperateDisable"
                                                        @click="changeSubnetwork(1)">
                                                    </el-button></span>
                                            </el-tooltip>
                                        </el-form-item>
                                    </el-col>
                                    <el-col :span="8">
                                        <el-form-item :label="$t('detail.text.interNetIpv4') | withColon">
                                            <span>{{ detail.extensionPrivateIp }}</span>
                                            <el-tooltip :disabled="!changeNetworkOperateDisable"
                                                :content='changeNetworkTip'>
                                                <span><el-button type="text" icon="jc-icon-edit"
                                                        :disabled="changeNetworkOperateDisable" @click="changeIPnetwork(1)">
                                                    </el-button></span>
                                            </el-tooltip>
                                        </el-form-item>
                                    </el-col>
                                    <el-col :span="8">
                                        <el-form-item :label="$t('detail.text.publicNetIpv4') | withColon">
                                            <span v-if="detail.extensionEnableInternet === 'yes'">
                                                <a href="javascript:void(0)"
                                                    @click="jumpToEip(detail.extensionElasticIpId, detail.region)">
                                                    {{ detail.extensionPublicIp }}
                                                </a>
                                            </span>
                                            <span v-else>
                                                {{ '--' }}
                                            </span>
                                        </el-form-item>
                                    </el-col>
                                    <el-col :span="8">
                                        <el-form-item :label="$t('detail.text.interNetIpv6') | withColon">
                                            <span v-if="detail.extensionIpv6Address">{{ detail.extensionIpv6Address
                                            }}</span>
                                            <a v-else @click="openIpv6PrivateNetInstance('subInternetAccess')"
                                                href="javascript:void(0)"
                                                :class="{ 'cps-dropdown-disabled': (!detail.extensionSubnetIpv6Cidr || !detail.extensionVpcIpv6Cidr) }">{{
                                                    this.$t('privateNetInstance.operations.ipv6') }}</a>
                                        </el-form-item>
                                    </el-col>
                                    <el-col :span="8" v-if="detail.extensionIpv6Address">
                                        <el-form-item :label="$t('privateNetInstance.isEnableIPv6') | withColon">
                                            <span v-if="detail.extensionIpv6AddressId">{{
                                                this.$t('privateNetInstance.hasEnabledIPv6') }}</span>
                                            <span v-else>
                                                {{ this.$t('privateNetInstance.hasDisabledIPv6') }}
                                                <a @click="jumpToIpv6Detail('subInternetAccess')"
                                                    href="javascript:void(0)">{{
                                                        this.$t('privateNetInstance.enablePublicNet') }}</a>
                                            </span>
                                        </el-form-item>
                                    </el-col>
                                    <el-col :span="8">
                                        <el-form-item :label="$t('detail.text.bondedAliasIpRange') | withColon">
                                            <a href="javascript:void(0)" @click="jumpToNetAccessDetail">
                                                {{ detail.extensionAliasIpTotal }}
                                            </a>
                                        </el-form-item>
                                    </el-col>
                                    <el-col :span="8">
                                        <el-form-item :label="$t('detail.text.bondedIPv6AliasIpRange') | withColon">
                                            <a href="javascript:void(0)" @click="jumpToNetAccessDetail">
                                                {{ detail.extensionIpv6AliasIpTotal }}
                                            </a>
                                        </el-form-item>
                                    </el-col>
                                </el-row>
                            </el-form>
                        </div>
                    </div>
                </el-tab-pane>
                <!-- tab:硬件监控 -->
                <el-tab-pane :label="$t('privateNetInstance.hardWareMonitor')" name="hardWareMonitor"
                    :disabled="tabName === 'hardWareMonitor'">
                    <!-- 硬件设备状态 -->
                    <div class="jc-section">
                        <div class="jc-section-header">
                            <h3 class="jc-section-title">{{ $t('detail.text.hardwareStatus') }}</h3>
                        </div>
                        <div class="jc-section-content">
                            <hardware-status :hardWareData="hardWareData"></hardware-status>
                        </div>
                    </div>
                    <!-- 报警日志列表 -->
                    <div class="jc-section mt20">
                        <div class="jc-section-header">
                            <h3 class="jc-section-title">
                                {{ $t('detail.text.warningLogList') }}
                            </h3>
                        </div>
                        <div class="jc-section-content">
                            <alarm-logs :eventLogs="infoLogData"></alarm-logs>
                        </div>
                    </div>
                    <div ref="footer" class="jc-page-footer-detail jc-container-table-actionBar" v-if="total">
                        <el-pagination @size-change="warningLogHandleSizeChange" @current-change="warningLogCurrentChange"
                            :current-page="warningLogCurrentPage" :page-sizes="warningLogPageSizes" :page-size="pageSize"
                            layout="total, sizes, prev, pager, next, jumper" :total="warningLogTotal">
                        </el-pagination>
                    </div>
                </el-tab-pane>
                <!-- tab:性能监控 -->
                <el-tab-pane v-if="detail.osType !== 'Windows'" :label="$t('detail.text.performanceMonitor')"
                    name="performanceMonitor" :disabled="tabName === 'performanceMonitor'">
                    <router-view v-if="hasMonitor"></router-view>
                </el-tab-pane>
                <!--网口详情Tab-->
                <el-tab-pane :label="$t('detail.text.netAccessDetail')" name="netAccessDetail"
                    :disabled="tabName === 'netAccessDetail'">
                    <!--基本信息-->
                    <div class="jc-section">
                        <div class="jc-section-header">
                            <h3 class="jc-section-title">
                                {{ $t('privateNetInstance.baseInfo') }}
                            </h3>
                        </div>
                        <div class="jc-section-content">
                            <el-form class="net-info-list">
                                <el-row :gutter="20">
                                    <el-col :span="8">
                                        <el-form-item :label="$t('detail.text.netAccessType') | withColon">
                                            <span>{{ detail.interfaceMode === 'bond' ?
                                                $t('create.text.singleInternetAccess')
                                                : $t('create.text.doubleInternetAccess') }}</span>
                                        </el-form-item>
                                    </el-col>
                                    <el-col :span="8">
                                        <el-form-item :label="$t('create.text.networkName') | withColon">
                                            <span>{{ detail.interfaceMode === 'bond' ?
                                                $t('create.text.singleInternetAccessChiefName') :
                                                $t('create.text.chiefAndSubInternetAccessName') }}</span>
                                        </el-form-item>
                                    </el-col>
                                </el-row>
                            </el-form>
                        </div>
                    </div>
                    <el-divider></el-divider>
                    <!--主网口-->
                    <div class="jc-section">
                        <div class="jc-section-header">
                            <h3 class="jc-section-title">
                                {{ detail.interfaceMode === 'dual' ? $t('create.text.chiefInternetAccessName') :
                                    $t('create.text.singleInternetAccessChiefName') }}
                            </h3>
                        </div>
                        <div class="jc-section-content">
                            <el-form class="net-info-list">
                                <el-row :gutter="20">
                                    <!-- 内网IPV4(主IP) -->
                                    <el-col :span="8">
                                        <el-form-item :label="$t('detail.text.interNetIpv4') | withColon">
                                            <span>{{ detail.privateIp }}</span>
                                        </el-form-item>
                                    </el-col>
                                    <!-- 公网IPV4(主IP) -->
                                    <el-col :span="8">
                                        <el-form-item :label="$t('detail.text.publicNetIpv4') | withColon">
                                            <span v-if="detail.enableInternet === 'yes'">
                                                {{ detail.publicIp }}
                                            </span>
                                            <span v-else>
                                                {{ '--' }}
                                            </span>
                                        </el-form-item>
                                    </el-col>
                                    <!-- 内网IPV6(主IP) -->
                                    <el-col :span="8">
                                        <el-form-item :label="$t('detail.text.interNetIpv6') | withColon">
                                            <span v-if="detail.ipv6Address">{{ detail.ipv6Address }}</span>
                                            <a v-else @click="openIpv6PrivateNetInstance('chiefInternetAccess')"
                                                href="javascript:void(0)"
                                                :class="{ 'cps-dropdown-disabled': (!detail.subnetIpv6Cidr || !detail.vpcIpv6Cidr) }">{{
                                                    this.$t('privateNetInstance.operations.ipv6') }}</a>
                                        </el-form-item>
                                    </el-col>
                                    <!-- 是否开通IPV6公网 -->
                                    <el-col :span="8" v-if="detail.ipv6Address">
                                        <el-form-item :label="$t('privateNetInstance.isEnableIPv6') | withColon">
                                            <span v-if="detail.ipv6AddressId">{{
                                                this.$t('privateNetInstance.hasEnabledIPv6') }}</span>
                                            <span v-else>
                                                {{ this.$t('privateNetInstance.hasDisabledIPv6') }}
                                                <a @click="jumpToIpv6Detail('chiefInternetAccess')"
                                                    href="javascript:void(0)">{{
                                                        this.$t('privateNetInstance.enablePublicNet') }}</a>
                                            </span>
                                        </el-form-item>
                                    </el-col>
                                </el-row>
                            </el-form>
                            <!--别名IP范围-->
                            <el-tabs>
                                <el-tab-pane :label="$t('subnet.text.ipAliasRange')">
                                    <el-table :data="primaryNetwork.alias.tableData" class="alias-ip-tab-table"
                                        max-height="450">
                                        <!--别名IP范围-->
                                        <el-table-column :label="$t('subnet.text.ipAliasRange')" prop="cidr" width="550">
                                            <template slot-scope="scope">
                                                <span>{{ scope.row.cidr | maybeEmpty }}</span>
                                            </template>
                                        </el-table-column>
                                        <!--分配来源-->
                                        <el-table-column :label="$t('subnet.text.allocacateSource')" prop="source"
                                            width="550">
                                            <template slot-scope="scope">
                                                <div v-if="scope.row.ipv6Cidr">
                                                    <p class="english-word-wrap">
                                                        {{ $t('subnet.text.primaryIpv6Cidr') + '(' + scope.row.primaryCidr +
                                                            ')' | maybeEmpty }}
                                                    </p>
                                                </div>
                                                <div v-else>
                                                    <p class="english-word-wrap" v-if="scope.row.primaryName">
                                                        {{ scope.row.primaryName + '(' + scope.row.primaryCidr + ')' |
                                                            maybeEmpty }}
                                                    </p>
                                                    <p class="english-word-wrap" v-else>
                                                        {{ $t('subnet.text.mainCidr') + '(' + scope.row.primaryCidr + ')' |
                                                            maybeEmpty }}
                                                    </p>
                                                </div>
                                            </template>
                                        </el-table-column>
                                        <!--操作-->
                                        <el-table-column :label="$t('listPage.tableLabel.operation')" prop="cidr"
                                            min-width="120">
                                            <template slot-scope="scope">
                                                <el-tooltip v-if="scope.row.isBondEip || detail.status === 'creating'"
                                                    :content="$t('subnet.help.usedDeleteNotAllowed')">
                                                    <span
                                                        :class="[{ 'a-disabled': scope.row.isBondEip || detail.status === 'creating' }]">
                                                        {{ $t('subnet.text.delete') }}
                                                    </span>
                                                </el-tooltip>
                                                <a v-else href="javascript:void(0)"
                                                    @click="aliasIpSelectOperations(AliasIpOperationConstant.DELETE, scope.row,
                                                        scope.row.isBondEip || detail.status === 'creating', 'primaryNetwork')">
                                                    {{ $t('subnet.text.delete') }}
                                                </a>
                                            </template>
                                        </el-table-column>
                                    </el-table>
                                    <div v-if="primaryNetwork.alias.total > 0"
                                        class="cps-page-footer-simple block jc-container-table-actionBar">
                                        <el-pagination
                                            @size-change="val => handleSizeChange(val, 'primaryNetwork', 'alias')"
                                            @current-change="val => handleCurrentChange(val, 'primaryNetwork', 'alias')"
                                            :current-page="primaryNetwork.alias.currentPage"
                                            :page-sizes="primaryNetwork.alias.pageSizes"
                                            :page-size="primaryNetwork.alias.pageSize"
                                            layout="total, sizes, prev, pager, next, jumper"
                                            :total="primaryNetwork.alias.total">
                                        </el-pagination>
                                    </div>
                                </el-tab-pane>
                                <!--弹性公网IPv4-->
                                <el-tab-pane :label="$t('eip.text.eipv4')">
                                    <el-table :data="primaryNetwork.eip.tableData" class="alias-ip-tab-table">
                                        <!--IP类型-->
                                        <el-table-column prop="elasticIp" width="410" :label="$t('detail.text.ipType')">
                                            <template slot-scope="scope">
                                                <span>{{ $t('eip.text.eip') }}</span>
                                            </template>
                                        </el-table-column>
                                        <!--IP地址-->
                                        <el-table-column prop="elasticIp" width="410"
                                            :label="$t('listPage.tableLabel.ipAddress')">
                                            <template slot-scope="scope">
                                                <span>{{ scope.row.elasticIp | maybeEmpty }}</span>
                                            </template>
                                        </el-table-column>
                                        <!--内网IP-->
                                        <el-table-column prop="elasticIp" width="410" :label="$t('detail.text.intranetIp')">
                                            <template slot-scope="scope">
                                                <span>{{ scope.row.targetIp | maybeEmpty }}</span>
                                            </template>
                                        </el-table-column>
                                        <!--操作-->
                                        <el-table-column :label="$t('listPage.tableLabel.operation')" prop="cidr"
                                            min-width="120">
                                            <template slot-scope="scope">
                                                <a href="javascript:void(0)" @click="selectOpts(EipOperationConstant.UNBIND, scope.row, 'unbind',
                                                    OverdueConstantArray.includes(scope.row.chargeStatus))"
                                                    v-if="scope.row.status === 'associate'"
                                                    :class="{ 'cps-dropdown-disabled': OverdueConstantArray.includes(scope.row.chargeStatus) }">
                                                    {{ $t('eip.text.unbindSource') }}
                                                </a>
                                            </template>
                                        </el-table-column>
                                    </el-table>
                                    <div v-if="primaryNetwork.eip.total > 0"
                                        class="cps-page-footer-simple block jc-container-table-actionBar">
                                        <el-pagination @size-change="val => handleSizeChange(val, 'primaryNetwork', 'eip')"
                                            @current-change="val => handleCurrentChange(val, 'primaryNetwork', 'eip')"
                                            :current-page="primaryNetwork.eip.currentPage"
                                            :page-sizes="primaryNetwork.eip.pageSizes"
                                            :page-size="primaryNetwork.eip.pageSize"
                                            layout="total, sizes, prev, pager, next, jumper"
                                            :total="primaryNetwork.eip.total">
                                        </el-pagination>
                                    </div>
                                </el-tab-pane>
                                <!--公网IPv6-->
                                <el-tab-pane :label="$t('detail.text.eipv6')">
                                    <el-table :data="primaryNetwork.ipv6.tableData" class="alias-ip-tab-table">
                                        <!--IPv6类型-->
                                        <el-table-column width="410" :label="$t('detail.text.typeIpv6')">
                                            <template slot-scope="scope">
                                                <span>{{ $t('detail.text.addressIpv6') | maybeEmpty }}</span>
                                            </template>
                                        </el-table-column>
                                        <!--IP地址-->
                                        <el-table-column width="410" :label="$t('listPage.tableLabel.ipAddress')">
                                            <template slot-scope="scope">
                                                <span>{{ scope.row.ipv6Address + '(' + transformCharge(scope.row.type) + ')'
                                                    |
                                                    maybeEmpty }}</span>
                                            </template>
                                        </el-table-column>
                                        <!--公网带宽-->
                                        <el-table-column width="410" :label="$t('detail.text.publicNetBandWidth')">
                                            <template slot-scope="scope">
                                                <span class="english-wrap">
                                                    {{ scope.row.bandwidth >= 0 ? scope.row.bandwidth + 'Mbps' : '--' }}
                                                </span>
                                                <p>
                                                    {{ $t('create.placeholder.fixedBandwidth') }}
                                                </p>
                                            </template>
                                        </el-table-column>
                                        <!--操作-->
                                        <el-table-column :label="$t('listPage.tableLabel.operation')" min-width="120">
                                            <template slot-scope="scope">
                                                <a href="javascript:void(0)" @click="deleteIpv6Address(scope.row)">
                                                    {{ $t('ipv6.text.deleteIpv6PublicNetwork') }}
                                                </a>
                                            </template>
                                        </el-table-column>
                                    </el-table>
                                    <div v-if="primaryNetwork.ipv6.total > 0"
                                        class="cps-page-footer-simple block jc-container-table-actionBar">
                                        <el-pagination @size-change="val => handleSizeChange(val, 'primaryNetwork', 'ipv6')"
                                            @current-change="val => handleCurrentChange(val, 'primaryNetwork', 'ipv6')"
                                            :current-page="primaryNetwork.ipv6.currentPage"
                                            :page-sizes="primaryNetwork.ipv6.pageSizes"
                                            :page-size="primaryNetwork.ipv6.pageSize"
                                            layout="total, sizes, prev, pager, next, jumper"
                                            :total="primaryNetwork.ipv6.total">
                                        </el-pagination>
                                    </div>
                                </el-tab-pane>
                            </el-tabs>
                        </div>
                    </div>
                    <el-divider></el-divider>

                    <!------- 辅网口 ----------->
                    <div v-if="detail.interfaceMode === 'dual'" class="jc-section" >
                        <div class="jc-section-header">
                            <h3 class="jc-section-title">
                                {{ $t('create.text.subInternetAccessName') }}
                            </h3>
                        </div>
                        <div class="jc-section-content">
                            <el-form class="net-info-list">
                                <el-row :gutter="20">
                                    <!-- 内网IPV4(主IP) -->
                                    <el-col :span="8">
                                        <el-form-item :label="$t('detail.text.interNetIpv4') | withColon">
                                            <span>{{ detail.extensionPrivateIp || '--'}}</span>
                                        </el-form-item>
                                    </el-col>
                                     <!-- 内网IPV4(主IP) -->
                                    <el-col :span="8">
                                        <el-form-item :label="$t('detail.text.publicNetIpv4') | withColon">
                                            <span v-if="detail.extensionEnableInternet === 'yes'">
                                                {{ detail.extensionPublicIp || '--'}}
                                            </span>
                                            <span v-else>
                                                {{ '--' }}
                                            </span>
                                        </el-form-item>
                                    </el-col>
                                    <!-- 内网IPV6(主IP) -->
                                    <el-col :span="8">
                                        <el-form-item :label="$t('detail.text.interNetIpv6') | withColon">
                                            <span v-if="detail.extensionIpv6Address">{{ detail.extensionIpv6Address
                                            }}</span>
                                            <a v-else @click="openIpv6PrivateNetInstance('subInternetAccess')"
                                                href="javascript:void(0)"
                                                :class="{ 'cps-dropdown-disabled': (!detail.extensionSubnetIpv6Cidr || !detail.extensionVpcIpv6Cidr) }">{{
                                                    this.$t('privateNetInstance.operations.ipv6') }}</a>
                                        </el-form-item>
                                    </el-col>
                                    <!-- 是否开通IPV6公网 -->
                                    <el-col :span="8" v-if="detail.extensionIpv6Address">
                                        <el-form-item :label="$t('privateNetInstance.isEnableIPv6') | withColon">
                                            <span v-if="detail.extensionIpv6AddressId">{{
                                                this.$t('privateNetInstance.hasEnabledIPv6') }}</span>
                                            <span v-else>
                                                {{ this.$t('privateNetInstance.hasDisabledIPv6') }}
                                                <a @click="jumpToIpv6Detail('subInternetAccess')"
                                                    href="javascript:void(0)">{{
                                                        this.$t('privateNetInstance.enablePublicNet') }}</a>
                                            </span>
                                        </el-form-item>
                                    </el-col>
                                </el-row>
                            </el-form>
                            <el-tabs>
                                <!-- 别名IP范围 -->
                                <el-tab-pane :label="$t('subnet.text.ipAliasRange')">
                                    <el-table :data="extensionNetwork.alias.tableData" class="alias-ip-tab-table"
                                        max-height="450">
                                        <!--别名IP范围-->
                                        <el-table-column :label="$t('subnet.text.ipAliasRange')" prop="cidr" width="550">
                                            <template slot-scope="scope">
                                                <span>{{ scope.row.cidr | maybeEmpty }}</span>
                                            </template>
                                        </el-table-column>
                                        <!--分配来源-->
                                        <el-table-column :label="$t('subnet.text.allocacateSource')" prop="source"
                                            width="550">
                                            <template slot-scope="scope">
                                                <div v-if="scope.row.ipv6Cidr">
                                                    <p class="english-word-wrap">
                                                        {{ $t('subnet.text.primaryIpv6Cidr') + '(' + scope.row.primaryCidr +
                                                            ')' | maybeEmpty }}
                                                    </p>
                                                </div>
                                                <div v-else>
                                                    <p class="english-word-wrap" v-if="scope.row.primaryName">
                                                        {{ scope.row.primaryName + '(' + scope.row.primaryCidr + ')' |
                                                            maybeEmpty }}
                                                    </p>
                                                    <p class="english-word-wrap" v-else>
                                                        {{ $t('subnet.text.mainCidr') + '(' + scope.row.primaryCidr + ')' |
                                                            maybeEmpty }}
                                                    </p>
                                                </div>

                                            </template>
                                        </el-table-column>
                                        <!--操作-->
                                        <el-table-column :label="$t('listPage.tableLabel.operation')" prop="cidr"
                                            min-width="120">
                                            <template slot-scope="scope">
                                                <el-tooltip v-if="scope.row.isBondEip || detail.status === 'creating'"
                                                    :content="$t('subnet.help.usedDeleteNotAllowed')">
                                                    <span
                                                        :class="[{ 'a-disabled': scope.row.isBondEip || detail.status === 'creating' }]">
                                                        {{ $t('subnet.text.delete') }}
                                                    </span>
                                                </el-tooltip>
                                                <a v-else href="javascript:void(0)"
                                                    @click="aliasIpSelectOperations(AliasIpOperationConstant.DELETE, scope.row,
                                                        scope.row.isBondEip || detail.status === 'creating', 'extensionNetwork')">
                                                    {{ $t('subnet.text.delete') }}
                                                </a>
                                            </template>
                                        </el-table-column>
                                    </el-table>
                                    <div v-if="extensionNetwork.alias.total > 0"
                                        class="cps-page-footer-simple block jc-container-table-actionBar">
                                        <el-pagination
                                            @size-change="val => handleSizeChange(val, 'extensionNetwork', 'alias')"
                                            @current-change="val => handleCurrentChange(val, 'extensionNetwork', 'alias')"
                                            :current-page="extensionNetwork.alias.currentPage"
                                            :page-sizes="extensionNetwork.alias.pageSizes"
                                            :page-size="extensionNetwork.alias.pageSize"
                                            layout="total, sizes, prev, pager, next, jumper"
                                            :total="extensionNetwork.alias.total">
                                        </el-pagination>
                                    </div>
                                </el-tab-pane>
                                <!-- 弹性公网IPV4 -->
                                <el-tab-pane :label="$t('eip.text.eipv4')">
                                    <el-table :data="extensionNetwork.eip.tableData" class="alias-ip-tab-table">
                                        <!--IP类型-->
                                        <el-table-column prop="elasticIp" width="410" :label="$t('detail.text.ipType')">
                                            <template slot-scope="scope">
                                                <span>{{ $t('eip.text.eip') }}</span>
                                            </template>
                                        </el-table-column>
                                        <!--IP地址-->
                                        <el-table-column prop="elasticIp" width="410"
                                            :label="$t('listPage.tableLabel.ipAddress')">
                                            <template slot-scope="scope">
                                                <span>{{ scope.row.elasticIp | maybeEmpty }}</span>
                                            </template>
                                        </el-table-column>
                                        <!--内网IP-->
                                        <el-table-column prop="elasticIp" width="410" :label="$t('detail.text.intranetIp')">
                                            <template slot-scope="scope">
                                                <span>{{ scope.row.targetIp | maybeEmpty }}</span>
                                            </template>
                                        </el-table-column>
                                        <!--操作-->
                                        <el-table-column :label="$t('listPage.tableLabel.operation')" prop="cidr"
                                            min-width="120">
                                            <template slot-scope="scope">
                                                <a href="javascript:void(0)" @click="selectOpts(EipOperationConstant.UNBIND, scope.row, 'unbind',
                                                    OverdueConstantArray.includes(scope.row.chargeStatus))"
                                                    v-if="scope.row.status === 'associate'"
                                                    :class="{ 'cps-dropdown-disabled': OverdueConstantArray.includes(scope.row.chargeStatus) }">
                                                    {{ $t('eip.text.unbindSource') }}
                                                </a>
                                            </template>
                                        </el-table-column>
                                    </el-table>
                                    <div v-if="extensionNetwork.eip.total > 0"
                                        class="cps-page-footer-simple block jc-container-table-actionBar">
                                        <el-pagination
                                            @size-change="val => handleSizeChange(val, 'extensionNetwork', 'eip')"
                                            @current-change="val => handleCurrentChange(val, 'extensionNetwork', 'eip')"
                                            :current-page="extensionNetwork.eip.currentPage"
                                            :page-sizes="extensionNetwork.eip.pageSizes"
                                            :page-size="extensionNetwork.eip.pageSize"
                                            layout="total, sizes, prev, pager, next, jumper"
                                            :total="extensionNetwork.eip.total">
                                        </el-pagination>
                                    </div>
                                </el-tab-pane>
                                <!-- 公网IPV6 -->
                                <el-tab-pane :label="$t('detail.text.eipv6')">
                                    <el-table :data="extensionNetwork.ipv6.tableData" class="alias-ip-tab-table">
                                        <!--IPv6类型-->
                                        <el-table-column prop="elasticIp" width="410" :label="$t('detail.text.typeIpv6')">
                                            <template slot-scope="scope">
                                                <span>{{ $t('detail.text.addressIpv6') }}</span>
                                            </template>
                                        </el-table-column>
                                        <!--IP地址-->
                                        <el-table-column prop="elasticIp" width="410"
                                            :label="$t('listPage.tableLabel.ipAddress')">
                                            <template slot-scope="scope">
                                                <span>{{ scope.row.ipv6Address + '(' + transformCharge(scope.row.type) + ')'
                                                    |
                                                    maybeEmpty }}</span>
                                            </template>
                                        </el-table-column>
                                        <!--公网带宽-->
                                        <el-table-column prop="elasticIp" width="410"
                                            :label="$t('detail.text.publicNetBandWidth')">
                                            <template slot-scope="scope">
                                                <span class="english-wrap">
                                                    {{ scope.row.bandwidth >= 0 ? scope.row.bandwidth + 'Mbps' : '--' }}
                                                </span>
                                                <p>
                                                    {{ $t('create.placeholder.fixedBandwidth') }}
                                                </p>
                                            </template>
                                        </el-table-column>
                                        <!--操作-->
                                        <el-table-column :label="$t('listPage.tableLabel.operation')" prop="cidr"
                                            min-width="120">
                                            <template slot-scope="scope">
                                                <a href="javascript:void(0)" @click="deleteIpv6Address(scope.row)">
                                                    {{ $t('ipv6.text.deleteIpv6PublicNetwork') }}
                                                </a>
                                            </template>
                                        </el-table-column>
                                    </el-table>
                                </el-tab-pane>
                            </el-tabs>
                        </div>
                    </div>
                </el-tab-pane>
            </el-tabs>
            <open :visible.sync="openInstance" :name="detail.name" :instanceId="detail.instanceId" :region="detail.region"
                @refresh="operateRefresh">
            </open>
            <close :visible.sync="closeInstance" :name="detail.name" :region="detail.region" :instanceId="detail.instanceId"
                @refresh="operateRefresh">
            </close>
            <restart :visible.sync="restartInstance" :name="detail.name" :region="detail.region"
                :instanceId="detail.instanceId" @refresh="operateRefresh">
            </restart>
            <reset-password :dialogVisible.sync="resetPasswordDialogVisible" :detail-data="detail"
                @refreshData="operateRefresh">
            </reset-password>
            <reinstall :visible.sync="reInstall" :rowInfo="detail" :clickToDetail='true' @sendedRequest="sendedRequest" v-if="reInstall">
            </reinstall>
            <re-network :visible.sync="reNetwork" :rowInfo="detail" :azs="azs" :az="regions[detail.az]"
                :region="detail.region" :vpcNotChange="vpcNotChange" :subnetNotChange="subnetNotChange"
                :networkNameTag="networkName" @refresh="operateRefresh" @sendedRequest="sendedRequest" v-if="reNetwork">
            </re-network>
            <bind-eip v-if="bindShow" :visible.sync="bindShow" :region="detail.region" :instanceId="detail.instanceId"
                :instanceName="detail.name" :rowInfo="detail" @refresh="bindEipSuccess">
            </bind-eip>
            <un-bind-eip :visible.sync="unBindShow" :elasticIpId="detail.elasticIpId" :publicIp="detail.publicIp"
                :region="detail.region" :instanceId="detail.instanceId" @refresh="unBindhEipSuccess">
            </un-bind-eip>
            <have-sos :visible.sync="sosShow" :rowInfo="detail" @refresh="operateRefresh">
            </have-sos>
            <fix-sos :visible.sync="fixSOSShow" :rowInfo="detail" @refresh="operateRefresh">
            </fix-sos>
            <reset-sos :visible.sync="resetSOSShow" :rowInfo="detail" @refresh="operateRefresh">
            </reset-sos>
            <jcb-opt-protect :visible.sync="operationProtectVisible" :action-type="actionType" @success="onSuccess"
                @error="onError">
            </jcb-opt-protect>
            <!--编辑标签-->
            <jcb-tag-edit :visible.sync="editTagDialogVisible" :service-code="ServiceCodeConstant.CPS"
                :region-id="detail.region !== undefined ? detail.region : ''"
                :resource-ids="detail.instanceId !== undefined ? [detail.instanceId] : []"
                @complete="showInstanceDetail(defaultParams)">
            </jcb-tag-edit>
            <!--添加别名ip范围-->
            <add-alias-ip-range-dialog :dialog-visible.sync="addIpAliasRangeDialogVisible" :detail-data="detail"
                @refreshDetailData="addAliasIpRangeSuccess">
            </add-alias-ip-range-dialog>
            <!--删除实例-->
            <delete-instance :visible.sync="deleteVisible" :rowInfo="detail" :pageSource="'detail'" @goList="goBack"
                @refresh="operateRefresh">
            </delete-instance>
            <!--开通ipv6-->
            <ipv6-privateNetInstance :visible.sync="ipv6PrivateNetInstanceShow" :region="region" :currentRow="detail"
                @refresh="operateRefresh">
            </ipv6-privateNetInstance>
            <!--ipv6公网删除-->
            <delete-ipv6 :visible.sync="deleteIpv6Visible" @refresh="operateRefresh" :rowInfo="currentRow">
            </delete-ipv6>
            <!--开启实例删除操作保护-->
            <enable-deletion-protection :visible.sync="enableDeletionProtectionVisible" :instanceName="detail.name"
                :region="detail.region" :instanceId="detail.instanceId" @refresh="operateRefresh">
            </enable-deletion-protection>
            <!--关闭实例删除操作保护-->
            <disable-deletion-protection :visible.sync="disableDeletionProtectionVisible" :instanceName="detail.name"
                :region="detail.region" :instanceId="detail.instanceId" @refresh="operateRefresh">
            </disable-deletion-protection>
            <!--制作镜像-->
            <make-mirror :visible.sync="makeMirrorVisible" v-if="makeMirrorVisible" @refresh="operateRefresh"
                :rowInfo="detail" :pageSource="'detail'">
            </make-mirror>
        </div>
    </div>
</template>

<script>

import copyValue from '@/components/privateNetwork/CopyValue';
import editValue from '@/components/privateNetwork/EditValue';
import dropDownOperation from '@/components/privateNetInstance/dropdownOperation/DropdownOperation';
import open from '@/components/privateNetInstance/operates/Open';
import close from '@/components/privateNetInstance/operates/Close';
import restart from '@/components/privateNetInstance/operates/Restart';
import reinstall from '@/components/privateNetInstance/reinstallSystem/reinstallSystemConfirm';
import ReNetwork from '@/components/privateNetInstance/operates/ReNetwork';
import BindEip from '@/components/common/BindEip';
import unBindEip from '@/components/common/UnBindEip';
import AgentStatus from '@/components/privateNetInstance/AgentStatus';
import ResetPassword from '@/components/common/resetPassword/ResetPassword';
import operationProtect from '@/mixins/operationProject';
import DeleteInstance from '@/components/common/DeleteInstance';
import DeleteIpv6 from '@/components/common/DeleteIpv6';
import HaveSos from '@/components/common/HaveSos';
import FixSos from '@/components/common/FixSos';
import ResetSos from '@/components/common/ResetSos';
import Ipv6PrivateNetInstance from '@/components/privateNetInstance/ipv6PrivateNetInstance/ipv6PrivateNetInstance';
import AddAliasIpRangeDialog from
    '@/components/common/addAliasIpRangeDialog/AddAliasIpRangeDialog';
import EnableDeletionProtection from '@/components/common/enableDeletionProtection/EnableDeletionProtection';
import DisableDeletionProtection from '@/components/common/disableDeletionProtection/DisableDeletionProtection';
import HardwareStatus from '@/components/common/hardwareStatus/HardwareStatus';
import AlarmLogs from '@/components/common/alarmLogs/AlarmLogs';
import makeMirror from '@/components/privateNetInstance/makeMirror/Index';
import { AliasIpOperations } from '@/common/AliasIpHelper'
import { operations } from '@/common/EipPopHelper';
import {
    ServiceCodeConstant,
    OverdueConstantArray,
    ChargeModeConstant,
    EipOperationConstant,
    AliasIpOperationConstant,
    DeleteProtectStatusConstant
} from "@/common/Constants";
import { deepCopy } from '@/common/tool';
import isDestroyingMixins from '@/mixins/isDestroying';
export default {
    name: 'InstanceDetail',
    components: {
        AgentStatus,
        BindEip,
        unBindEip,
        copyValue,
        editValue,
        dropDownOperation,
        restart,
        reinstall,
        ReNetwork,
        open,
        close,
        ResetPassword,
        DeleteInstance,
        DeleteIpv6,
        Ipv6PrivateNetInstance,
        AddAliasIpRangeDialog,
        HaveSos,
        FixSos,
        ResetSos,
        EnableDeletionProtection,
        DisableDeletionProtection,
        HardwareStatus,
        AlarmLogs,
        makeMirror
    },
    mixins: [operationProtect, isDestroyingMixins],
    data() {
        const valName = (rule, value, callback) => {
            const reg = new RegExp('^[a-zA-Z\\\u4e00-\\\u9fa5]([0-9a-zA-Z\\\u4e00-\\\u9fa5-_.:]{1,127})$');
            if (!reg.test(value)) {
                callback(new Error(this.$t('create.help.instanceNameRule')));
            } else {
                callback();
            }
        };
        const valDes = (rule, value, callback) => {
            if (value.length > 256) {
                callback(new Error(this.$t('detail.speechCraft.descriptionLongRule')));
            } else {
                callback();
            }
        };
        return {
            isDropDownOperationLoading: false,
            showEditDes: false,
            showEditName: false,
            networkName: 'eth0',
            tabName: '',
            rules: {
                name: [
                    {
                        required: true,
                        message: this.$t('privateNetwork.nameNotNull'),
                    },
                    {
                        validator: valName,
                    }
                ],
                description: [
                    {
                        validator: valDes,
                    }
                ]
            },
            reSysForm: {},
            reSystemInfo: {},
            openInstance: false,
            closeInstance: false,
            restartInstance: false,
            repasswordInstance: false,
            reInstall: false,
            reNetwork: false,
            changeNetworkOperateDisable: false,
            resetSosDisable: false,
            bindShow: false,
            unBindShow: false,
            // 删除ipv6公网弹框
            deleteIpv6Visible: false,
            currentRow: {},
            vpcNotChange: false,
            subnetNotChange: false,
            changeNetworkTip: '',
            operateMap: {
                stopped: [
                    'restart'
                ],
                running: [
                    'reinstall',
                    'reNetwork',
                    'resetPassword',
                    'delete'
                ],
                error: [
                    'start',
                    'turnOff',
                    'restart',
                    'resetPassword',
                    'reinstall',
                    'reNetwork',
                    'bandWidth',
                    'renew',
                    'editTag',
                    'turnOnDeleteProtect',
                    'turnOffDeleteProtect',
                    'delete',
                    'ipv6',
                ],
                creating: [
                    'start',
                    'turnOff',
                    'restart',
                    'resetPassword',
                    'reinstall',
                    'reNetwork',
                    'bandWidth',
                    'renew',
                    'sos',
                    'editTag',
                    'turnOnDeleteProtect',
                    'turnOffDeleteProtect',
                    'delete',
                    'ipv6',
                ],
                upgrading: [
                    'start',
                    'turnOff',
                    'restart',
                    'resetPassword',
                    'reinstall',
                    'reNetwork',
                    'bandWidth',
                    'renew',
                    'editTag',
                    'turnOnDeleteProtect',
                    'turnOffDeleteProtect',
                    'delete',
                    'ipv6',
                ],
                destroying: [
                    'start',
                    'turnOff',
                    'restart',
                    'resetPassword',
                    'reinstall',
                    'reNetwork',
                    'bandWidth',
                    'renew',
                    'editTag',
                    'turnOnDeleteProtect',
                    'turnOffDeleteProtect',
                    'delete',
                    'ipv6',
                ],
                other: [
                    'start',
                    'turnOff',
                    'restart',
                    'resetPassword',
                    'reinstall',
                    'reNetwork',
                    'bandWidth',
                    'editTag',
                    'turnOnDeleteProtect',
                    'turnOffDeleteProtect',
                    'delete',
                    'ipv6',
                ],
                noOperate: [
                    'starting',
                    'running',
                    'stopping',
                    'stopped',
                    'error',
                    'restarting',
                    'creating',
                    'destroying',
                    'upgrading',
                    'reinstalling',
                    'turnOnDeleteProtect',
                    'turnOffDeleteProtect',
                    'delete',
                    'ipv6',
                ]
            },
            statusListMap: {
                'starting': 'other',
                'running': 'running',
                'stopping': 'other',
                'stopped': 'stopped',
                'error': 'error',
                'restarting': 'other',
                'creating': 'creating',
                'destroying': 'destroying',
                'upgrading': 'upgrading',
                'reinstalling': 'other',
                'noOprate': 'noOperate',
                'other': 'other',
                'inconfig': 'other',
                'resetting_password': 'other',
                'making': 'other'
            },
            interStatus: [
                'creating',
                'starting',
                'stopping',
                'restarting',
                'upgrading',
                'reinstalling',
                'destroying',
                'inconfig',
                'resetting_password',
                'making'
            ],
            statusMapName: {
                'creating': this.$t('privateNetInstance.statueNames.creating'),
                'starting': this.$t('privateNetInstance.statueNames.starting'),
                'running': this.$t('privateNetInstance.statueNames.running'),
                'stopping': this.$t('privateNetInstance.statueNames.stopping'),
                'stopped': this.$t('privateNetInstance.statueNames.stopped'),
                'restarting': this.$t('privateNetInstance.statueNames.restarting'),
                'error': this.$t('privateNetInstance.statueNames.error'),
                'upgrading': this.$t('privateNetInstance.statueNames.upgrading'),
                'reinstalling': this.$t('privateNetInstance.statueNames.reinstalling'),
                'destroying': this.$t('privateNetInstance.statueNames.destroying'),
                'inconfig': this.$t('privateNetInstance.statueNames.inconfig'),
                'resetting_password': this.$t('listPage.text.resettingPassword'),
                'making': this.$t('privateNetInstance.statueNames.making'),
            },
            renew: false,
            total: 0,
            detail: {},
            operations: [],
            azs: [],
            hardWareData: [],
            infoLogData: [],
            defaultParams: '',
            ops: [],
            flexPublicNetList: [],
            instanceId: '',
            region: '',
            // 给操作保护用区分物理机类型：basic/vpc
            instanceType: 'vpc',
            // 重装密码弹框是否可见
            resetPasswordDialogVisible: false,
            // 存储region和regionName
            regions: {},
            // 编辑标签组件是否显示
            editTagDialogVisible: false,
            // 添加别名IP范围dialog
            addIpAliasRangeDialogVisible: false,
            // 批量编辑标签组件是否显示
            batchEditTagDialogVisible: true,
            // 删除实例弹框
            deleteVisible: false,
            // 开通ipv6弹框
            ipv6PrivateNetInstanceShow: false,
            sosShow: false,
            fixSOSShow: false,
            resetSOSShow: false,
            openSOS: false,
            hasMonitor: false,
            warningLogPageSize: 20,
            warningLogPageSizes: [20, 50, 100], // 可选每页展示多少条
            warningLogTotal: 0,
            warningLogCurrentPage: 1,
            // 主网口别名IP范围列表分页相关数据
            primaryNetwork: {
                alias: {
                    tableData: [],
                    tableDataLoading: false,
                    total: 0,
                    pageSize: 10,
                    pageSizes: [10, 20, 50, 100],
                    currentPage: 1,
                },
                eip: {
                    tableData: [],
                    tableDataLoading: false,
                    total: 0,
                    pageSize: 10,
                    pageSizes: [10, 20, 50, 100],
                    currentPage: 1,
                },
                ipv6: {
                    tableData: [],
                    tableDataLoading: false,
                    total: 0,
                    pageSize: 10,
                    pageSizes: [10, 20, 50, 100],
                    currentPage: 1,
                }
            },
            // 辅网口别名IP范围列表分页相关数据
            extensionNetwork: {
                alias: {
                    tableData: [],
                    tableDataLoading: false,
                    total: 0,
                    pageSize: 10,
                    pageSizes: [10, 20, 50, 100],
                    currentPage: 1,
                },
                eip: {
                    tableData: [],
                    tableDataLoading: false,
                    total: 0,
                    pageSize: 10,
                    pageSizes: [10, 20, 50, 100],
                    currentPage: 1,
                },
                ipv6: {
                    tableData: [],
                    tableDataLoading: false,
                    total: 0,
                    pageSize: 10,
                    pageSizes: [10, 20, 50, 100],
                    currentPage: 1,
                }
            },
            // 开启实例删除操作保护弹框
            enableDeletionProtectionVisible: false,
            // 关闭实例删除操作保护弹框
            disableDeletionProtectionVisible: false,
            // 中间状态下获取详情数据定时器
            statusTimeOut: null,
            // 制作镜像弹框
            makeMirrorVisible: false,
            sn: '',
        };
    },
    computed: {
        OverdueConstantArray: () => OverdueConstantArray,
        ServiceCodeConstant: () => ServiceCodeConstant,
        ChargeModeConstant: () => ChargeModeConstant,
        EipOperationConstant: () => EipOperationConstant,
        AliasIpOperationConstant: () => AliasIpOperationConstant,
        DeleteProtectStatusConstant: () => DeleteProtectStatusConstant
    },
    watch: {
        '$route'(to, from) {
            this.tabName = this.$route.query.tabName;
            if (this.tabName === 'netAccessDetail') {
                this.refreshAliasIpsListData();
                this.refreshEipListData();
                this.refreshIpv6ListData();
            }
        }
    },
    created() {
        const {region, id, az, sn, tabName} = this.$route.query || {};
        this.tabName = tabName;
        this.sn = sn;
        this.instanceId = id;
        this.region = region;
        const params = {
            region,
            instanceId: id,
            az,
        };
        this.defaultParams = params;
        this.showInstanceDetail(params);
        this.getRegionNames();
        if (this.tabName === 'netAccessDetail') {
            this.refreshAliasIpsListData();
            this.refreshEipListData();
            this.refreshIpv6ListData();
        }
        if (this.tabName === 'performanceMonitor') {
            this.hasMonitor = true;
        }
    },
    destroyed() {
        clearTimeout(this.statusTimeOut);
    },
    methods: {
        // 用于右上角的各个弹窗操作确定后，接口响应中不可点击其他按钮，防止重复状态影响操作
        sendedRequest(value) {
            this.isDropDownOperationLoading = value;
        },
        /**
         * 点击跳转初始密钥详情
         * @param keyPairId
         * @param region
        */
        jumpToKeyPairDetail(keypairId, region) {
            this.$router.push({
                path: '/ssh/detail',
                query: {
                    id: keypairId,
                    region
                }
            });
        },
        /**
         * 获得region和regionName对照
        */
        getRegionNames() {
            const params = {
                networkType: 'vpc'
            };
            Ajax.get('api/cps/getRegions', params).then((res) => {
                const target = this;
                if (res.data) {
                    res.data.regions.forEach((region) => {
                        target.regions[region.region] = region.regionName;
                        region.azs.forEach((az) => {
                            target.regions[az.az] = az.azName;
                        })
                    });
                }
            });
        },
        // 切换顶部资源信息、硬件监控、网口详情等tab
        changeTab(tab) {
            this.hasMonitor = false;
            if (tab.name === 'hardWareMonitor') {
                const params = {
                    sn: this.sn,
                    region: this.region
                };
                this.getDescribeInstanceStatus(params);
                this.getDescribeEventLog(params)
            } else if (tab.name === 'performanceMonitor') {
                this.hasMonitor = true;
                let query = this.$route.query;
                query.tabName = 'performanceMonitor'
                this.$router.push({
                    path: `${this.$route.path.replace(/\/performance/g, '')}/performance`,
                    query: {
                        ...query,
                        imageType: this.detail.imageType
                    }
                });
            } else if (tab.name === 'netAccessDetail') {
                let query = this.$route.query;
                query.tabName = 'netAccessDetail'
                this.$router.push({
                    path: `${this.$route.path.replace(/\/performance/g, '')}/performance`,
                    query: query
                });
                const bond = this.detail.interfaceMode;
                this.getAliasIpsListData(true, 'primaryNetwork');
                this.getEipList('primaryNetwork');
                this.getIPv6List('primaryNetwork')
                if (bond === 'dual') {
                    this.getAliasIpsListData(true, 'extensionNetwork');
                    this.getEipList('extensionNetwork');
                    this.getIPv6List('extensionNetwork')
                }
            } else {
                let query = this.$route.query;
                query.tabName = 'sourceInfo'
                this.$router.push({
                    path: `${this.$route.path.replace(/\/performance/g, '')}/performance`,
                    query: query
                });
            }
        },
        // 获取弹性公网列表
        getFlexPublicNetList() {
            const params = {
                region: this.detail.region,
                status: 'disassociate'
            };
            Ajax.get('/api/cps/listElasticIps', params)
                .then((res) => {
                    this.flexPublicNetList = res.data.elasticIps;
                })
                .catch()
                .finally();
        },
        operateRefresh() {
            const params = {
                region: this.detail.region,
                instanceId: this.detail.instanceId,
                az: this.detail.az,
                sn: this.sn
            };
            this.defaultParams = params;
            this.showInstanceDetail(params);
        },
        afterOperateBind() {
            this.operateRefresh();
        },
        clickOperate(item) {
            switch (item) {
                case 'bind':
                    this.bindShow = true;
                    break;
                case 'unbind':
                    this.unBindShow = true;
                    break;
                case 'rePassword':
                    Pop.resetPassword(this, this.detail);
                    break;
                case 'ipv6':
                    this.ipv6PrivateNetInstanceShow = true;
                    break;
                case 'makeMirror':
                    this.makeMirrorVisible = true;
                    break;
                case 'repay':
                    this.renewInstance(this.detail.instanceId);
                    break;
                case 'reInstall':
                    this.reInstall = true;
                    break;
                case 'reNetwork':
                    this.reNetwork = true;
                    this.networkName = 'eth0'
                    this.vpcNotChange = false;
                    this.subnetNotChange = false;
                    break;
                case 'open':
                    Pop.vpcInstance_open(this, this.detail, 'detail');
                    break;
                case 'close':
                    Pop.vpcInstance_close(this, this.detail, 'detail');
                    break;
                case 'restart':
                    Pop.vpcInstace_restart(this, this.detail, 'detail');
                    break;
                case 'addIpAlias':
                    this.addIpAliasRangeDialogVisible = true;
                    break;
                case 'sos':
                    this.sosShow = true;
                    break;
                case 'fixSos':
                    this.fixSOSShow = true;
                    break;
                case 'resetSos':
                    this.resetSOSShow = true;
                    break;
                case 'editTag':
                    this.editTagDialogVisible = true;
                    break;
                case 'delete':
                    this.deleteVisible = true;
                    break;
                case 'turnOnDeleteProtect':
                    this.enableDeletionProtectionVisible = true;
                    break;
                case 'turnOffDeleteProtect':
                    this.disableDeletionProtectionVisible = true;
                default:
                    break;
            }
        },
        sosFix() {
            if (this.detail.keypairIdSos !== undefined) {
                this.sosShow = true;
            } else {
                this.fixSOSShow = true;
            }
        },
        sosReset() {
            this.resetSOSShow = true
        },
        openIpv6PrivateNetInstance(type) {
            if (type === 'chiefInternetAccess') {
                if (!this.detail.subnetIpv6Cidr || !this.detail.vpcIpv6Cidr) {
                    return
                }
            } else if (type === 'subInternetAccess') {
                if (!this.detail.extensionSubnetIpv6Cidr || !this.detail.extensionVpcIpv6Cidr) {
                    return
                }
            }

            this.ipv6PrivateNetInstanceShow = true;
        },
        renewInstance(id) {
            const params = {
                resourceId: id,
                region: this.detail.region,
                serviceCode: ServiceCodeConstant.CPS
            };
            Ajax.get('/api/order/submitRenew', params)
                .then((res) => {
                    const tempOrderId = res.data.tmpOrderId;
                    window.location.href = `${this.Config.RENEW_CONSOLE_URL}/orderConfirmPageIp?requestId=${tempOrderId}&resourceType=cps`;
                });
        },
        goBack() {
            this.$router.push({
                path: '/instance/vpc/list',
                query: {
                    region: this.detail.region
                }
            });
        },
        showInstanceDetail(params) {
            if (this.isDestroying) {
                return
            }
            this.getInstanceDetail(params).then(() => {
                if (this.interStatus.includes(this.detail.status)) {
                    clearTimeout(this.statusTimeOut);
                    this.statusTimeOut = setTimeout(() => {
                        this.showInstanceDetail(params)
                    }, 5000);
                }
                if (this.tabName === 'netAccessDetail') {
                    this.refreshAliasIpsListData();
                    this.refreshEipListData();
                    this.refreshIpv6ListData();
                }
            }).catch(async (err) => {
                const { response } = err.data;
                try {
                    const json = await response.json();
                    this.$message.error(json.errmsg);
                } catch (e) {
                    console.log(e);
                }
            });
        },
        getInstanceDetail(params) {
            this.renew = false;
            return Ajax.get('/api/cps/getInstanceInfo', params)
                .then((res) => {
                    if (res.data) {
                        this.detail = res.data.instance;
                        // 镜像
                        this.detail.imageName = `${res.data.instance.osName}(${res.data.instance.imageKindName})`
                        // 显卡信息
                        this.detail.graphics = res.data.instance.cpsConfiguration.deviceType.gpuConcise;
                        // deviceInformation
                        this.detail.deviceInfo = res.data.instance.cpsConfiguration.deviceType;
                        this.detail.chargeMode = res.data.instance.charge.chargeMode;
                        // 登录密钥对特殊处理
                        this.detail.keypairName = res.data.instance.keypairName && res.data.instance.keypairName.join(' | ');
                        // 格式化标签键值对
                        const tagPairs = res.data.instance.tags;
                        this.detail.tagPairs = ''
                        if (tagPairs !== undefined) {
                            if (tagPairs.length > 0) {
                                for (const tag of tagPairs) {
                                    this.detail.tagPairs += `${tag.key}:${tag.value},`;
                                }
                                this.detail.tagPairs = this.detail.tagPairs.substring(0, this.detail.tagPairs.length - 1)
                            }
                        }
                        // 获取sn
                        this.sn = res.data?.instance?.sn || this.$route.query.sn;
                        this.dealCustomPartition(this.detail.customPartition);
                        this.ops = this.initOperations(this.detail);
                    }
                }).catch(async (err) => {
                    this.detail = {};
                    const { response } = err.data;
                    try {
                        const json = await response.json();
                        this.$message.error(json.errmsg);
                    } catch (e) {
                        console.log(e);
                    }
                });
        },

        // 最近一次安装系统分区参数处理
        dealCustomPartition(customPartition) {
            let customSystemPartition = this.partitionsFormatter(customPartition.systemDiskPartitions);
            let customDataPartition = this.partitionsFormatter(customPartition.dataDiskPartitions);
            this.detail.customSystemPartition = customSystemPartition;
            this.detail.customDataPartition = customDataPartition;
        },

        // 格式化分区信息
        partitionsFormatter(partitions) {
            return partitions.reduce((init, current) => {
                let size;
                if (current.size === 999999999) {
                    size = this.$t('retailInstance.text.allRemainingSpace');
                } else {
                    size = current.size / 1024 + 'GiB';
                }
                return `${init}<strong class="ml5 mr5">${current.point}:</strong>${size},${current.format};`
            }, '');
        },

        // 获取硬件设备状态列表
        getDescribeInstanceStatus(params) {
            this.hardWareData = [];
            Ajax.get('/api/cps/describeInstanceStatus', params)
                .then((res) => {
                    this.hardWareData.push(
                        {
                            name: 'CPU',
                            status: res.data.cpus
                        },
                        {
                            name: this.$t('detail.text.memory'),
                            status: res.data.mems
                        },
                        {
                            name: this.$t('detail.text.hardDisk'),
                            status: res.data.disks
                        },
                        {
                            name: this.$t('detail.text.netCard'),
                            status: res.data.nics
                        },
                        {
                            name: this.$t('detail.text.power'),
                            status: res.data.powerStatus
                        },
                        {
                            name: this.$t('detail.text.other'),
                            status: res.data.otherStatus
                        },
                    );
                }).catch(err => {
                    const { response } = err.data;
                    try {
                        const json = response.json();
                        this.$message.error(json.errmsg);
                    } catch (ex) {
                        console.log(ex);
                    }
                });
        },
        // 获取报警日志列表
        getDescribeEventLog(params) {
            Ajax.get('/api/cps/oob/listDeviceAlertLog', params)
                .then((res) => {
                    this.infoLogData = res.data && res.data.list;
                    this.warningLogTotal = res.data.list.length
                }).catch(async (err) => {
                    const { response } = err.data;
                    try {
                        const json = await response.json();
                        this.$message.error(json.errmsg);
                    } catch (ex) {
                        console.log(ex);
                    }
                });
        },
        warningLogHandleSizeChange(val) {
            this.pageSize = val;
            const param = {
                instanceId: this.instanceId,
                region: this.region,
                pageSize: this.pageSize,
                sn: this.sn,
            };
            this.getDescribeEventLog(param);
        },

        warningLogCurrentChange(val) {
            this.currentPage = val;
            const param = {
                instanceId: this.instanceId,
                region: this.region,
                pageSize: this.pageSize,
                sn: this.sn,
            };
            this.getDescribeEventLog(param);
        },
        // 编辑名称
        editName(value) {
            this.renew = false;
            const params = {
                region: this.detail.region,
                instanceId: this.detail.instanceId,
                name: value
            };
            Ajax.post('/api/cps/modifyInstanceName', params)
                .then((res) => {
                    if (res.data) {
                        this.detail.name = res.data.name;
                    }
                }).finally(() => {
                    this.renew = true;
                });
        },
        // 编辑描述
        editDes(value) {
            this.renew = false;
            const params = {
                region: this.detail.region,
                instanceId: this.detail.instanceId,
                description: value
            };
            Ajax.post('/api/cps/modifyInstanceDescription', params)
                .then((res) => {
                    if (res.data) {
                        this.detail.description = res.data.description;
                    }
                })
                .finally(() => {
                    this.renew = true;
                });
        },
        transformChargeMode(type) {
            switch (type) {
                case 'postpaid_by_duration':
                    return this.$t('listPage.text.postpaid_by_duration');
                    break;
                default:
                    return this.$t('privateNetInstance.monthAndYear');
                    break;
            }
        },
        transformVpcName(type) {
            switch (type) {
                default:
                    return this.$t('privateNetInstance.privateNet');
            }
        },
        jumpToSubnet(id, region) {
            this.$router.push({
                path: '/subnet/detail',
                query: {
                    id,
                    region
                }
            });
        },
        jumpToEip(id, region) {
            this.$router.push({
                path: `/eip/detail/${id}/${region}`,
            });
        },
        jumpToNetAccessDetail() {
            let query = deepCopy(this.$route.query)
            query.tabName = 'netAccessDetail';
            this.$router.push({ query: query })
        },
        jumpToVpcDetail(id, region, name) {
            this.$router.push({
                path: '/vpc/detail',
                query: {
                    id,
                    region,
                    tabName: 'source',
                    vpcName: name
                }
            });
        },
        jumpToIpv6Detail(type) {
            let subnetId = type === 'chiefInternetAccess' ? this.detail.subnetId : this.detail.extensionSubnetId;
            let ipv6GatewayId = type === 'chiefInternetAccess' ? this.detail.ipv6GatewayId : this.detail.extensionIpv6GatewayId;
            this.$router.push({
                path: '/ipv6/detail',
                query: {
                    id: ipv6GatewayId,
                    tabName: 'ipv6Eip',
                    region: this.detail.region,
                    subnetId: subnetId
                }
            });
        },
        changeVpcNetwork(val) {
            this.reNetwork = true;
            this.vpcNotChange = false;
            this.subnetNotChange = false;
            if (val === 0) {
                this.networkName = 'eth0'
            } else {
                this.networkName = 'eth1'
            }

        },
        changeSubnetwork(val) {
            this.vpcNotChange = true;
            this.subnetNotChange = false;
            this.reNetwork = true;
            if (val === 0) {
                this.networkName = 'eth0'
            } else {
                this.networkName = 'eth1'
            }
        },
        changeIPnetwork(val) {
            this.reNetwork = true;
            this.vpcNotChange = true;
            this.subnetNotChange = true;
            if (val === 0) {
                this.networkName = 'eth0'
            } else {
                this.networkName = 'eth1'
            }
        },
        getClassByStatue(statue) {
            if (typeof statue === 'undefined') {
                return ['jc-status', 'my-status', 'my-status-middle', 'mt16'];
            }
            switch (statue) {
                case 'running':
                    return ['jc-status-success'];
                case 'error':
                    return ['my-error-status', 'jc-status-danger'];
                case 'stopped':
                    return ['jc-status-warning'];
                default:
                    // return ['jc-status', 'my-status', 'my-status-middle', 'mt12'];
                    return ['jc-status', 'my-status', 'my-status-middle', ''];
            }
        },
        transFormStatusName(status) {
            return this.statusMapName[status];
        },
        initOperations() {
            const item = this.detail;
            const operations = [];
            // 兼容status人工误修改的情况
            let operate = this.statusListMap[item.status] || 'other';
            // 开机及关机
            if (item.status === 'stopped') {
                operations.push({
                    operateName: this.$t('privateNetInstance.open'),
                    disabled: OverdueConstantArray.includes(item.charge.chargeStatus)
                        || this.operateMap[operate].indexOf('start') > -1
                        || !item.charge.chargeStatus,
                    tip: !item.charge.chargeStatus ? this.$t('eip.help.noChargeInfo') : OverdueConstantArray.includes(item.charge.chargeStatus) ? this.$t('privateNetInstance.operations.overdueTip') : this.$t('privateNetInstance.operations.onlyShutDown'),
                    value: 'open'
                });
            } else {
                operations.push({
                    operateName: this.$t('privateNetInstance.shutdown'),
                    disabled: OverdueConstantArray.includes(item.charge.chargeStatus)
                        || this.operateMap[operate].indexOf('turnOff') > -1
                        || !item.charge.chargeStatus,
                    tip: !item.charge.chargeStatus ? this.$t('eip.help.noChargeInfo') : OverdueConstantArray.includes(item.charge.chargeStatus) ? this.$t('privateNetInstance.operations.overdueTip') : this.$t('privateNetInstance.operations.onlyRunning'),
                    value: 'close'
                });
            }
            // 重启
            operations.push({
                operateName: this.$t('privateNetInstance.restart'),
                disabled: OverdueConstantArray.includes(item.charge.chargeStatus)
                    || this.operateMap[operate].indexOf('restart') > -1
                    || !item.charge.chargeStatus,
                tip: !item.charge.chargeStatus ? this.$t('eip.help.noChargeInfo') : OverdueConstantArray.includes(item.charge.chargeStatus) ? this.$t('privateNetInstance.operations.overdueTip') : this.$t('privateNetInstance.operations.onlyRunning'),
                value: 'restart'
            });
            // 重置密码
            operations.push({
                operateName: this.$t('privateNetInstance.operations.rePassword'),
                disabled: this.operateMap[operate].indexOf('resetPassword') !== -1
                    || OverdueConstantArray.includes(item.charge.chargeStatus)
                    || !item.charge.chargeStatus,
                tip: !item.charge.chargeStatus ? this.$t('eip.help.noChargeInfo') : OverdueConstantArray.includes(item.charge.chargeStatus) ? this.$t('privateNetInstance.operations.overdueTip') : this.$t('privateNetInstance.operations.onlyShutDown'),
                value: 'rePassword'
            });
            // 重装系统
            operations.push({
                operateName: this.$t('privateNetInstance.operations.reOperateSystem'),
                disabled: this.operateMap[operate].indexOf('reinstall') > -1
                    || OverdueConstantArray.includes(item.charge.chargeStatus)
                    || !item.charge.chargeStatus,
                tip: !item.charge.chargeStatus ? this.$t('eip.help.noChargeInfo') : OverdueConstantArray.includes(item.charge.chargeStatus) ? this.$t('privateNetInstance.operations.overdueTip') : this.$t('privateNetInstance.operations.onlyShutDown'),
                value: 'reInstall'
            });
            //更换私有网络
            const changeNetworkOperate = {
                operateName: this.$t('privateNetInstance.operations.reVpcnetWork'),
                disabled: this.operateMap[operate].indexOf('reNetwork') > -1
                    || OverdueConstantArray.includes(item.charge.chargeStatus)
                    || item.checkModifyVpc?.ifSlb
                    || item.checkModifyVpc?.ifAliasIp
                    || item.checkModifyVpc?.ifIPv6
                    || item.checkModifyVpc?.ifEip
                    || item.checkModifyVpc?.ifNatRules
                    || !item.charge?.chargeStatus,
                tip: '',
                value: 'reNetwork'
            };
            if (item.checkModifyVpc?.ifAliasIp) {
                changeNetworkOperate.tip = this.$t('privateNetInstance.operations.alreadyBindOtherIp');
            }
            if (item.checkModifyVpc?.ifEip) {
                changeNetworkOperate.tip = this.$t('privateNetInstance.operations.alreadyBindEip');
            }
            if (item.checkModifyVpc?.ifIPv6) {
                changeNetworkOperate.tip = this.$t('privateNetInstance.operations.alreadyHaveIPv6');
            }
            if (item.checkModifyVpc?.ifNatRules) {
                changeNetworkOperate.tip = this.$t('privateNetInstance.operations.alreadyHaveNatRules');
            }
            if (item.checkModifyVpc?.ifSlb) {
                changeNetworkOperate.tip = this.$t('privateNetInstance.operations.alreadyAddLb');
            }
            if (item.status !== 'stopped') {
                changeNetworkOperate.tip = this.$t('privateNetInstance.operations.onlyShutDown');
            }
            if (OverdueConstantArray.includes(item.charge.chargeStatus)) {
                changeNetworkOperate.tip = this.$t('privateNetInstance.operations.overdueTip');
            }
            if (!item.charge.chargeStatus) {
                changeNetworkOperate.tip = this.$t('eip.help.noChargeInfo');
            }
            this.changeNetworkTip = changeNetworkOperate.tip;
            this.changeNetworkOperateDisable = changeNetworkOperate.disabled;
            operations.push(changeNetworkOperate);
            // 添加别名IP范围
            const addIpAliasRangeOperate = {
                operateName: this.$t('subnet.text.addIpAliasRange'),
                disabled: (item.status !== 'running' && item.status !== 'stopped')
                    || typeof item.charge.chargeStatus === 'undefined'
                    || OverdueConstantArray.includes(item.charge.chargeStatus)
                    || (item.isCheckAliasIpTotal >= 50 && item.extensionAliasIpTotal >= 50)
                    || this.instanceByConfigOpesDisabled(item),
                tip: '',
                value: 'addIpAlias'
            };
            if (item.isCheckAliasIpTotal >= 50 && item.extensionAliasIpTotal >= 50) {
                addIpAliasRangeOperate.tip = this.$t('subnet.help.only10IpAliasForOneInstance');
            }
            if (item.status !== 'running' && item.status !== 'stopped') {
                addIpAliasRangeOperate.tip = this.$t('privateNetInstance.operations.onlyNotError');
            }
            if (OverdueConstantArray.includes(item.charge.chargeStatus)) {
                addIpAliasRangeOperate.tip = this.$t('privateNetInstance.operations.overdueTip');
            }
            if (!item.charge.chargeStatus) {
                addIpAliasRangeOperate.tip = this.$t('eip.help.noChargeInfo');
            }
            operations.push(addIpAliasRangeOperate);
            // 开通ipv6
            const ipv6Disabled = (item) => {
                if (item.interfaceMode === 'bond') {
                    return !!item.ipv6Address || (!item.ipv6Address && (!item.subnetIpv6Cidr || !item.vpcIpv6Cidr));
                } else if (item.interfaceMode === 'dual') {
                    return (!!item.ipv6Address && !!item.extensionIpv6Address) || (!item.ipv6Address && (!item.subnetIpv6Cidr || !item.vpcIpv6Cidr) && !item.extensionIpv6Address && (!item.extensionSubnetIpv6Cidr || !item.extensionVpcIpv6Cidr));
                }
            };
            operations.push({
                operateName: this.$t('privateNetInstance.operations.ipv6'),
                disabled: this.operateMap[operate].indexOf('ipv6') > -1 || ipv6Disabled(item) || OverdueConstantArray.includes(item.charge.chargeStatus) || !item.charge.chargeStatus,
                tip: !item.charge.chargeStatus ? this.$t('eip.help.noChargeInfo') : OverdueConstantArray.includes(item.charge.chargeStatus) ? this.$t('privateNetInstance.operations.overdueTip') : (item.ipv6Address && item.extensionIpv6Address) ? this.$t('privateNetInstance.operations.onlyOneIpv6') : '',
                value: 'ipv6'
            });
            // 绑定弹性公网IP,一个实例可以绑定多个
            operations.push({
                operateName: this.$t('privateNetInstance.operations.bind'),
                disabled: (item.status !== 'running'
                    && item.status !== 'stopped')
                    || typeof item.charge.chargeStatus === 'undefined'
                    || OverdueConstantArray.includes(item.charge.chargeStatus)
                    || this.instanceByConfigOpesDisabled(item),
                tip: !item.charge.chargeStatus ? this.$t('eip.help.noChargeInfo') : OverdueConstantArray.includes(item.charge.chargeStatus) ? this.$t('privateNetInstance.operations.overdueTip') : this.$t('privateNetInstance.operations.onlyNotError'),
                value: 'bind'
            });
            // 解绑弹性公网IP
            if (item.enableInternet === 'yes') {
                operations.push({
                    operateName: this.$t('privateNetInstance.operations.unbind'),
                    disabled: (item.status !== 'running'
                        && item.status !== 'stopped')
                        || typeof item.charge.chargeStatus === 'undefined'
                        || OverdueConstantArray.includes(item.charge.chargeStatus)
                        || this.instanceByConfigOpesDisabled(item),
                    tip: !item.charge.chargeStatus ? this.$t('eip.help.noChargeInfo') : OverdueConstantArray.includes(item.charge.chargeStatus) ? this.$t('privateNetInstance.operations.overdueTip') : this.$t('privateNetInstance.operations.onlyNotError'),
                    value: 'unbind'
                });
            }
            // sos操作相关
            let sosTip = item.imageType === "Windows" ? this.$t('privateNetInstance.operations.notWindows') : "";
            if (item.keypairIdSos !== undefined) {
                //SOS
                operations.push({
                    operateName: this.$t('privateNetInstance.operations.sos'),
                    disabled: OverdueConstantArray.includes(item.charge.chargeStatus)
                        || item.imageType === 'Windows'
                        || !item.charge.chargeStatus,
                    tip: !item.charge.chargeStatus ? this.$t('eip.help.noChargeInfo') : OverdueConstantArray.includes(item.charge.chargeStatus) ? this.$t('privateNetInstance.operations.overdueTip') : sosTip,
                    value: 'sos'
                });
                //重置SOS
                operations.push({
                    operateName: this.$t('privateNetInstance.operations.resetSOS'),
                    disabled: OverdueConstantArray.includes(item.charge.chargeStatus)
                        || item.imageType === 'Windows'
                        || !item.charge.chargeStatus,
                    tip: !item.charge.chargeStatus ? this.$t('eip.help.noChargeInfo') : OverdueConstantArray.includes(item.charge.chargeStatus) ? this.$t('privateNetInstance.operations.overdueTip') : sosTip,
                    value: 'resetSos'
                });
                this.resetSosDisable = item.imageType === 'Windows' || OverdueConstantArray.includes(item.charge.chargeStatus) || !item.charge.chargeStatus;
            } else {
                // 修复SOS
                operations.push({
                    operateName: this.$t('privateNetInstance.operations.fixSOS'),
                    disabled: OverdueConstantArray.includes(item.charge.chargeStatus)
                        || item.imageType === 'Windows'
                        || !item.charge.chargeStatus,
                    tip: !item.charge.chargeStatus ? this.$t('eip.help.noChargeInfo') : OverdueConstantArray.includes(item.charge.chargeStatus) ? this.$t('privateNetInstance.operations.overdueTip') : sosTip,
                    value: 'fixSos'
                });
                this.resetSosDisable = item.imageType === 'Windows' || OverdueConstantArray.includes(item.charge.chargeStatus) || !item.charge.chargeStatus;
            };
            //制作镜像
            operations.push({
                operateName: this.$t('privateNetInstance.operations.makeMirror'),
                disabled: item.status !== 'stopped' || OverdueConstantArray.includes(item.charge.chargeStatus) || item.deviceSource !== 'common' || item.customPartition.dataDiskPartitions.some(item => item.point === '/var') || !item.charge.chargeStatus,
                tip: !item.charge.chargeStatus ? this.$t('eip.help.noChargeInfo') : OverdueConstantArray.includes(item.charge.chargeStatus) ? this.$t('privateNetInstance.operations.overdueTip') : item.deviceSource !== 'common' ? this.$t('privateNetInstance.operations.wrongDeviceType') : (item.status !== 'stopped' ? this.$t('privateNetInstance.operations.onlyShutDown') : ''),
                value: 'makeMirror'
            });
            // 续费
            operations.push({
                operateName: this.$t('privateNetInstance.operations.repay'),
                disabled: this.operateMap[operate].indexOf('renew') > -1
                    || item.charge.chargeStatus === undefined,
                tip: !item.charge.chargeStatus ? this.$t('eip.help.noChargeInfo') : '',
                value: 'repay'
            });
            // 编辑标签
            operations.push({
                operateName: this.$t('operations.edit_tag.name'),
                disabled: this.operateMap[operate].indexOf('editTag') > -1
                    || typeof item.charge.chargeStatus === 'undefined',
                tip: !item.charge.chargeStatus ? this.$t('eip.help.noChargeInfo') : this.$t('operations.edit_tag.tip'),
                value: 'editTag'
            });
            // 开启实例删除保护
            if (item.removeProtect === 'no') {
                const turnOnDeleteProtect = {
                    operateName: this.$t('operations.turnOnDeleteProtect.name'),
                    disabled: item.chargeMode === ChargeModeConstant.PREPAID_BY_DURATION
                        || typeof item.charge.chargeStatus === 'undefined'
                        || this.operateMap[operate].indexOf('turnOnDeleteProtect') > -1
                        || this.instanceByConfigOpesDisabled(item),
                    value: 'turnOnDeleteProtect',
                    tip: ''
                };
                if (item.chargeMode === ChargeModeConstant.PREPAID_BY_DURATION) {
                    turnOnDeleteProtect.tip = this.$t('operations.turnOnDeleteProtect.prepaidTip')
                }
                if (this.instanceByConfigOpesDisabled(item)) {
                    turnOnDeleteProtect.tip = this.$t('operations.turnOnDeleteProtect.tip')
                }
                if (!item.charge.chargeStatus) {
                    turnOnDeleteProtect.tip = this.$t('eip.help.noChargeInfo')
                }
                operations.push(turnOnDeleteProtect);
            }
            // 关闭实例删除保护
            if (item.removeProtect === 'yes') {
                const turnOffDeleteProtect = {
                    operateName: this.$t('operations.turnOffDeleteProtect.name'),
                    disabled: item.chargeMode === ChargeModeConstant.PREPAID_BY_DURATION
                        || typeof item.charge.chargeStatus === 'undefined'
                        || this.operateMap[operate].indexOf('turnOffDeleteProtect') > -1
                        || this.instanceByConfigOpesDisabled(item),
                    value: 'turnOffDeleteProtect',
                    tip: ''
                };
                if (item.chargeMode === ChargeModeConstant.PREPAID_BY_DURATION) {
                    turnOffDeleteProtect.tip = this.$t('operations.turnOnDeleteProtect.prepaidTip')
                }
                if (this.instanceByConfigOpesDisabled(item)) {
                    turnOffDeleteProtect.tip = this.$t('operations.turnOffDeleteProtect.tip')
                }
                if (!item.charge.chargeStatus) {
                    turnOffDeleteProtect.tip = this.$t('eip.help.noChargeInfo')
                }
                operations.push(turnOffDeleteProtect);
            }
            // 删除实例
            const deleteOperate = {
                operateName: this.$t('operations.delete.name'),
                disabled: item.chargeMode === ChargeModeConstant.PREPAID_BY_DURATION
                    || typeof item.charge.chargeStatus === 'undefined'
                    || this.operateMap[operate].indexOf('delete') > -1
                    || item.status === 'stopped' && !!item.ipv6AddressId
                    || item.removeProtect === 'yes',
                value: 'delete',
                tip: ''
            };
            if (item.chargeMode === ChargeModeConstant.POSTPAID_BY_DURATION && item.status === 'stopped' && item.ipv6AddressId) {
                deleteOperate.tip = this.$t('operations.delete.tipWithIPv6')
            }
            if (item.removeProtect === 'yes') {
                deleteOperate.tip = this.$t('operations.delete.tipWithRemoveProtect')
            }
            if (this.operateMap[operate].indexOf('delete') > -1) {
                deleteOperate.tip = this.$t('operations.delete.tipWithStatus');
            }
            if (item.chargeMode === ChargeModeConstant.PREPAID_BY_DURATION) {
                deleteOperate.tip = this.$t('operations.delete.tip')
            }
            if (!item.charge.chargeStatus) {
                deleteOperate.tip = this.$t('eip.help.noChargeInfo')
            }
            operations.push(deleteOperate);
            return operations;
        },
        /**
            * 当按配置购买的实例处于欠费状态时
            * 除删除操作外，其余操作置灰
            * @param item
            * @return {boolean}
        */
        instanceByConfigOpesDisabled(item) {
            return item.charge.chargeMode === ChargeModeConstant.POSTPAID_BY_DURATION
                && OverdueConstantArray.includes(item.charge.chargeStatus);
        },

        // 别名IP范围操作
        aliasIpSelectOperations(optCase, row, disabled, type) {
            if (disabled) {
                return false;
            }
            AliasIpOperations(optCase, this, row, type);

        },
        // 切换当前页
        handleCurrentChange(val, networkType, listType) {
            this[networkType][listType].currentPage = val;
            if (listType === 'alias') {
                this.getAliasIpsListData(false, networkType)
            } else if (listType === 'eip') {
                this.getEipList(networkType);
            } else if (listType === 'ipv6') {
                this.getIPv6List(networkType);
            }
        },
        // 切换每页展示条数
        handleSizeChange(val, networkType, listType) {
            this[networkType][listType].pageSize = val;
            if (listType === 'alias') {
                this.getAliasIpsListData(false, networkType);
            } else if (listType === 'eip') {
                this.getEipList(networkType);
            } else if (listType === 'ipv6') {
                this.getIPv6List(networkType);
            }
        },

        // 获取别名IP范围列表数据
        getAliasIpsListData(refresh, networkType) {
            this[networkType].alias.tableDataLoading = true;
            const param = {
                region: this.region,
                pageNumber: this[networkType].alias.currentPage,
                pageSize: this[networkType].alias.pageSize,
                instanceId: this.$route.query.id,
                scope: 'all',
                subnetId: networkType === 'primaryNetwork' ? this.detail.subnetId : this.detail.extensionSubnetId
            };
            Ajax.get('/api/cps/listAliasIps', param)
                .then((res) => {
                    const data = res.data;
                    const list = data.aliasIps;
                    this[networkType].alias.tableData = list;
                    this[networkType].alias.total = data.totalCount;
                })
                .finally(() => {
                    this[networkType].alias.tableDataLoading = false;
                });
        },
        // 获取弹性公网IPV4列表
        getEipList(networkType) {
            this[networkType].eip.tableDataLoading = true;
            const params = {
                region: this.detail.region,
                pageNumber: this[networkType].eip.currentPage,
                pageSize: this[networkType].eip.pageSize,
                instanceId: this.$route.query.id,
                subnetId: networkType === 'primaryNetwork' ? this.detail.subnetId : this.detail.extensionSubnetId,
                status: 'associate',
                // @TODO 过滤掉实例绑定的主网口的弹性公网IP @海龙
            };
            Ajax.get('/api/cps/listElasticIps', params)
                .then((res) => {
                    if (networkType === 'primaryNetwork') {
                        // this[networkType].eip.tableData = res.data.elasticIps.filter(item => {
                        //     return item.targetIp !== this.detail.privateIp
                        // }).map(item => {
                        //     item.chargeStatus = item.charge.chargeStatus;
                        //     return item
                        // });

                        this[networkType].eip.tableData = res.data?.elasticIps?.map(item => {
                            item.chargeStatus = item.charge.chargeStatus;
                            return item
                        });
                        // 过滤掉实例绑定的主网口的弹性公网IP && 返回的弹性公网IP列表长度大于0
                        // if (this.detail.privateIp && res.data.totalCount) {
                        //     this[networkType].eip.total = res.data.totalCount - 1;
                        // }
                    } else if (networkType === 'extensionNetwork') {
                        // this[networkType].eip.tableData = res.data.elasticIps.filter(item => {
                        //     return item.targetIp !== this.detail.extensionPrivateIp
                        // }).map(item => {
                        //     item.chargeStatus = item.charge.chargeStatus;
                        //     return item
                        // });
                        this[networkType].eip.tableData = res.data?.elasticIps?.map(item => {
                            item.chargeStatus = item.charge.chargeStatus;
                            return item
                        });
                        // 过滤掉实例绑定的辅网口的弹性公网IP && 返回的弹性公网IP列表长度大于0
                        // if (this.detail.extensionPrivateIp && res.data.totalCount) {
                        //     this[networkType].eip.total = res.data.totalCount - 1;
                        // }
                    }
                    // this[networkType].eip.total = this[networkType].eip.tableData.length;
                    this[networkType].eip.total = res.data.totalCount;
                })
                .catch()
                .finally(() => {
                    this[networkType].eip.tableDataLoading = false;
                });
        },
        // 获取ipv6公网列表
        getIPv6List(networkType) {
            this[networkType].ipv6.tableDataLoading = true;
            const params = {
                region: this.detail.region,
                pageNumber: this[networkType].ipv6.currentPage,
                pageSize: this[networkType].ipv6.pageSize,
                instanceId: this.$route.query.id,
                subnetId: networkType === 'primaryNetwork' ? this.detail.subnetId : this.detail.extensionSubnetId,
                enableInternet: 'yes'
            };
            Ajax.get('/api/cps/queryListIpv6Addresses', params)
                .then((res) => {
                    if (networkType === 'primaryNetwork') {
                        this[networkType].ipv6.tableData = res.data.ipv6Addresses.map(item => {
                            item.chargeStatus = item.charge.chargeStatus;
                            return item
                        });
                    } else if (networkType === 'extensionNetwork') {
                        this[networkType].ipv6.tableData = res.data.ipv6Addresses.map(item => {
                            item.chargeStatus = item.charge.chargeStatus;
                            return item
                        });
                    }
                    // this[networkType].ipv6.total = this[networkType].ipv6.tableData.length;
                    this[networkType].ipv6.total = res.data.totalCount;
                })
                .catch()
                .finally(() => {
                    this[networkType].ipv6.tableDataLoading = false;
                });
        },

        transformCharge(type) {
            switch (type) {
                case 'rip':
                    return this.$t('ipv6.text.rip');
                case 'aliasip':
                    return this.$t('ipv6.text.aliasip');
                default:
                    return '';
            }
        },

        selectOpts(caseOps, cps, operate, disabled, otherDisabled) {
            if (disabled) {
                return;
            }
            operations(caseOps, this, cps, 'detail');
        },

        deleteIpv6Address(row) {
            this.currentRow = row;
            this.deleteIpv6Visible = true;
        },

        refreshAliasIpsListData() {
            const bond = this.detail.interfaceMode;
            this.getAliasIpsListData(true, 'primaryNetwork');
            if (bond === 'dual') {
                this.getAliasIpsListData(true, 'extensionNetwork');
            }
        },

        refreshEipListData() {
            const bond = this.detail.interfaceMode;
            this.getEipList('primaryNetwork');
            if (bond === 'dual') {
                this.getEipList('extensionNetwork');
            }
        },

        refreshIpv6ListData() {
            const bond = this.detail.interfaceMode;
            this.getIPv6List('primaryNetwork');
            if (bond === 'dual') {
                this.getIPv6List('extensionNetwork');
            }
        },

        addAliasIpRangeSuccess() {
            this.showInstanceDetail(this.defaultParams);
            this.refreshAliasIpsListData();
        },

        bindEipSuccess() {
            this.showInstanceDetail(this.defaultParams);
            this.refreshEipListData();
            this.refreshIpv6ListData();
        },

        unBindhEipSuccess() {
            this.showInstanceDetail(this.defaultParams);
            this.refreshEipListData();
            this.refreshIpv6ListData();
        }
    },
};
</script>

<style lang="scss">
@import "~@/assets/scss/detailCommon.scss";
@import '~@/assets/scss/paginationCommon';
@import "instanceDetail";</style>

<style lang="scss" scoped>
.destroying-header {
    align-items: center !important;
    .el-page-header__content {
       .long-name {
            padding-top: 3px;
       }
    }
}
</style>



// WEBPACK FOOTER //
// src/views/privateNetInstance/detail/InstanceDetail.vue